var items = {
  "block.minecraft.acacia_button": "Akaasianappi",
  "block.minecraft.acacia_door": "Akaasiaovi",
  "block.minecraft.acacia_fence": "Akaasia-aita",
  "block.minecraft.acacia_fence_gate": "Akaasiaportti",
  "block.minecraft.acacia_hanging_sign": "Roikkuva akaasiakyltti",
  "block.minecraft.acacia_leaves": "Akaasianlehdet",
  "block.minecraft.acacia_log": "Akaasiahalko",
  "block.minecraft.acacia_planks": "Akaasialankut",
  "block.minecraft.acacia_pressure_plate": "Akaasiapainelaatta",
  "block.minecraft.acacia_sapling": "Akaasian taimi",
  "block.minecraft.acacia_shelf": "Akaasiahylly",
  "block.minecraft.acacia_sign": "Akaasiakyltti",
  "block.minecraft.acacia_slab": "Akaasialaatta",
  "block.minecraft.acacia_stairs": "Akaasiaportaat",
  "block.minecraft.acacia_trapdoor": "Akaasialuukku",
  "block.minecraft.acacia_wall_hanging_sign": "Riippuva akaasiakyltti",
  "block.minecraft.acacia_wall_sign": "Ripustettu akaasiakyltti",
  "block.minecraft.acacia_wood": "Akaasiapuu",
  "block.minecraft.activator_rail": "Aktivointiraide",
  "block.minecraft.air": "Ilma",
  "block.minecraft.allium": "Laukka",
  "block.minecraft.amethyst_block": "Ametistikuutio",
  "block.minecraft.amethyst_cluster": "Ametistirykelmä",
  "block.minecraft.ancient_debris": "Muinainen romu",
  "block.minecraft.andesite": "Andesiitti",
  "block.minecraft.andesite_slab": "Andesiittilaatta",
  "block.minecraft.andesite_stairs": "Andesiittiportaat",
  "block.minecraft.andesite_wall": "Andesiittimuuri",
  "block.minecraft.anvil": "Alasin",
  "block.minecraft.attached_melon_stem": "Kytkeytynyt melonin varsi",
  "block.minecraft.attached_pumpkin_stem": "Kytkeytynyt kurpitsan varsi",
  "block.minecraft.azalea": "Atsalea",
  "block.minecraft.azalea_leaves": "Atsaleanlehdet",
  "block.minecraft.azure_bluet": "Keijunsilmä",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Bambukuutio",
  "block.minecraft.bamboo_button": "Bambunappi",
  "block.minecraft.bamboo_door": "Bambuovi",
  "block.minecraft.bamboo_fence": "Bambuaita",
  "block.minecraft.bamboo_fence_gate": "Bambuportti",
  "block.minecraft.bamboo_hanging_sign": "Roikkuva bambukyltti",
  "block.minecraft.bamboo_mosaic": "Bambumosaiikki",
  "block.minecraft.bamboo_mosaic_slab": "Bambumosaiikkilaatta",
  "block.minecraft.bamboo_mosaic_stairs": "Bambumosaiikkiportaat",
  "block.minecraft.bamboo_planks": "Bambulankut",
  "block.minecraft.bamboo_pressure_plate": "Bambupainelaatta",
  "block.minecraft.bamboo_sapling": "Bambunverso",
  "block.minecraft.bamboo_shelf": "Bambuhylly",
  "block.minecraft.bamboo_sign": "Bambukyltti",
  "block.minecraft.bamboo_slab": "Bambulaatta",
  "block.minecraft.bamboo_stairs": "Bambuportaat",
  "block.minecraft.bamboo_trapdoor": "Bambuluukku",
  "block.minecraft.bamboo_wall_hanging_sign": "Riippuva bambukyltti",
  "block.minecraft.bamboo_wall_sign": "Ripustettu bambukyltti",
  "block.minecraft.banner.base.black": "Täysin musta pohja",
  "block.minecraft.banner.base.blue": "Täysin sininen pohja",
  "block.minecraft.banner.base.brown": "Täysin ruskea pohja",
  "block.minecraft.banner.base.cyan": "Täysin syaani pohja",
  "block.minecraft.banner.base.gray": "Täysin harmaa pohja",
  "block.minecraft.banner.base.green": "Täysin vihreä pohja",
  "block.minecraft.banner.base.light_blue": "Täysin vaaleansininen pohja",
  "block.minecraft.banner.base.light_gray": "Täysin vaaleanharmaa pohja",
  "block.minecraft.banner.base.lime": "Täysin limetinvihreä pohja",
  "block.minecraft.banner.base.magenta": "Täysin purppura pohja",
  "block.minecraft.banner.base.orange": "Täysin oranssi pohja",
  "block.minecraft.banner.base.pink": "Täysin vaaleanpunainen pohja",
  "block.minecraft.banner.base.purple": "Täysin violetti pohja",
  "block.minecraft.banner.base.red": "Täysin punainen pohja",
  "block.minecraft.banner.base.white": "Täysin valkoinen pohja",
  "block.minecraft.banner.base.yellow": "Täysin keltainen pohja",
  "block.minecraft.banner.border.black": "Musta reunus",
  "block.minecraft.banner.border.blue": "Sininen reunus",
  "block.minecraft.banner.border.brown": "Ruskea reunus",
  "block.minecraft.banner.border.cyan": "Syaani reunus",
  "block.minecraft.banner.border.gray": "Harmaa reunus",
  "block.minecraft.banner.border.green": "Vihreä reunus",
  "block.minecraft.banner.border.light_blue": "Vaaleansininen reunus",
  "block.minecraft.banner.border.light_gray": "Vaaleanharmaa reunus",
  "block.minecraft.banner.border.lime": "Limetinvihreä reunus",
  "block.minecraft.banner.border.magenta": "Purppura reunus",
  "block.minecraft.banner.border.orange": "Oranssi reunus",
  "block.minecraft.banner.border.pink": "Vaaleanpunainen reunus",
  "block.minecraft.banner.border.purple": "Violetti reunus",
  "block.minecraft.banner.border.red": "Punainen reunus",
  "block.minecraft.banner.border.white": "Valkoinen reunus",
  "block.minecraft.banner.border.yellow": "Keltainen reunus",
  "block.minecraft.banner.bricks.black": "Musta tiilikuvio",
  "block.minecraft.banner.bricks.blue": "Sininen tiilikuvio",
  "block.minecraft.banner.bricks.brown": "Ruskea tiilikuvio",
  "block.minecraft.banner.bricks.cyan": "Syaani tiilikuvio",
  "block.minecraft.banner.bricks.gray": "Harmaa tiilikuvio",
  "block.minecraft.banner.bricks.green": "Vihreä tiilikuvio",
  "block.minecraft.banner.bricks.light_blue": "Vaaleansininen tiilikuvio",
  "block.minecraft.banner.bricks.light_gray": "Vaaleanharmaa tiilikuvio",
  "block.minecraft.banner.bricks.lime": "Limetinvihreä tiilikuvio",
  "block.minecraft.banner.bricks.magenta": "Purppura tiilikuvio",
  "block.minecraft.banner.bricks.orange": "Oranssi tiilikuvio",
  "block.minecraft.banner.bricks.pink": "Vaaleanpunainen tiilikuvio",
  "block.minecraft.banner.bricks.purple": "Violetti tiilikuvio",
  "block.minecraft.banner.bricks.red": "Punainen tiilikuvio",
  "block.minecraft.banner.bricks.white": "Valkoinen tiilikuvio",
  "block.minecraft.banner.bricks.yellow": "Keltainen tiilikuvio",
  "block.minecraft.banner.circle.black": "Musta ympyrä",
  "block.minecraft.banner.circle.blue": "Sininen ympyrä",
  "block.minecraft.banner.circle.brown": "Ruskea ympyrä",
  "block.minecraft.banner.circle.cyan": "Syaani ympyrä",
  "block.minecraft.banner.circle.gray": "Harmaa ympyrä",
  "block.minecraft.banner.circle.green": "Vihreä ympyrä",
  "block.minecraft.banner.circle.light_blue": "Vaaleansininen ympyrä",
  "block.minecraft.banner.circle.light_gray": "Vaaleanharmaa ympyrä",
  "block.minecraft.banner.circle.lime": "Limetinvihreä ympyrä",
  "block.minecraft.banner.circle.magenta": "Purppura ympyrä",
  "block.minecraft.banner.circle.orange": "Oranssi ympyrä",
  "block.minecraft.banner.circle.pink": "Vaaleanpunainen ympyrä",
  "block.minecraft.banner.circle.purple": "Violetti ympyrä",
  "block.minecraft.banner.circle.red": "Punainen ympyrä",
  "block.minecraft.banner.circle.white": "Valkoinen ympyrä",
  "block.minecraft.banner.circle.yellow": "Keltainen ympyrä",
  "block.minecraft.banner.creeper.black": "Musta creeper",
  "block.minecraft.banner.creeper.blue": "Sininen creeper",
  "block.minecraft.banner.creeper.brown": "Ruskea creeper",
  "block.minecraft.banner.creeper.cyan": "Syaani creeper",
  "block.minecraft.banner.creeper.gray": "Harmaa creeper",
  "block.minecraft.banner.creeper.green": "Vihreä creeper",
  "block.minecraft.banner.creeper.light_blue": "Vaaleansininen creeper",
  "block.minecraft.banner.creeper.light_gray": "Vaaleanharmaa creeper",
  "block.minecraft.banner.creeper.lime": "Limetinvihreä creeper",
  "block.minecraft.banner.creeper.magenta": "Purppura creeper",
  "block.minecraft.banner.creeper.orange": "Oranssi creeper",
  "block.minecraft.banner.creeper.pink": "Vaaleanpunainen creeper",
  "block.minecraft.banner.creeper.purple": "Violetti creeper",
  "block.minecraft.banner.creeper.red": "Punainen creeper",
  "block.minecraft.banner.creeper.white": "Valkoinen creeper",
  "block.minecraft.banner.creeper.yellow": "Keltainen creeper",
  "block.minecraft.banner.cross.black": "Musta vinoristi",
  "block.minecraft.banner.cross.blue": "Sininen vinoristi",
  "block.minecraft.banner.cross.brown": "Ruskea vinoristi",
  "block.minecraft.banner.cross.cyan": "Syaani vinoristi",
  "block.minecraft.banner.cross.gray": "Harmaa vinoristi",
  "block.minecraft.banner.cross.green": "Vihreä vinoristi",
  "block.minecraft.banner.cross.light_blue": "Vaaleansininen vinoristi",
  "block.minecraft.banner.cross.light_gray": "Vaaleanharmaa vinoristi",
  "block.minecraft.banner.cross.lime": "Limetinvihreä vinoristi",
  "block.minecraft.banner.cross.magenta": "Purppura vinoristi",
  "block.minecraft.banner.cross.orange": "Oranssi vinoristi",
  "block.minecraft.banner.cross.pink": "Vaaleanpunainen vinoristi",
  "block.minecraft.banner.cross.purple": "Violetti vinoristi",
  "block.minecraft.banner.cross.red": "Punainen vinoristi",
  "block.minecraft.banner.cross.white": "Valkoinen vinoristi",
  "block.minecraft.banner.cross.yellow": "Keltainen vinoristi",
  "block.minecraft.banner.curly_border.black": "Musta hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.blue": "Sininen hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.brown": "Ruskea hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.cyan": "Syaani hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.gray": "Harmaa hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.green": "Vihreä hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.light_blue": "Vaaleansininen hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.light_gray": "Vaaleanharmaa hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.lime": "Limetinvihreä hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.magenta": "Purppura hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.orange": "Oranssi hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.pink": "Vaaleanpunainen hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.purple": "Violetti hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.red": "Punainen hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.white": "Valkoinen hammaskoroinen reunus",
  "block.minecraft.banner.curly_border.yellow": "Keltainen hammaskoroinen reunus",
  "block.minecraft.banner.diagonal_left.black": "Musta lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.blue": "Sininen lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.brown": "Ruskea lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.cyan": "Syaani lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.gray": "Harmaa lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.green": "Vihreä lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.light_blue": "Vaaleansininen lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.light_gray": "Vaaleanharmaa lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.lime": "Limetinvihreä lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.magenta": "Purppura lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.orange": "Oranssi lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.pink": "Vaaleanpunainen lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.purple": "Violetti lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.red": "Punainen lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.white": "Valkoinen lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_left.yellow": "Keltainen lakiovastalohkoinen",
  "block.minecraft.banner.diagonal_right.black": "Musta lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.blue": "Sininen lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.brown": "Ruskea lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.cyan": "Syaani lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.gray": "Harmaa lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.green": "Vihreä lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.light_blue": "Vaaleansininen lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.light_gray": "Vaaleanharmaa lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.lime": "Limetinvihreä lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.magenta": "Purppura lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.orange": "Oranssi lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.pink": "Vaaleanpunainen lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.purple": "Violetti lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.red": "Punainen lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.white": "Valkoinen lakiolohkoinen",
  "block.minecraft.banner.diagonal_right.yellow": "Keltainen lakiolohkoinen",
  "block.minecraft.banner.diagonal_up_left.black": "Musta tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.blue": "Sininen tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.brown": "Ruskea tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.cyan": "Syaani tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.gray": "Harmaa tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.green": "Vihreä tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Vaaleansininen tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Vaaleanharmaa tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.lime": "Limetinvihreä tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purppura tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranssi tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.pink": "Vaaleanpunainen tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.purple": "Violetti tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.red": "Punainen tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.white": "Valkoinen tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_left.yellow": "Keltainen tyviölohkoinen",
  "block.minecraft.banner.diagonal_up_right.black": "Musta tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.blue": "Sininen tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.brown": "Ruskea tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.cyan": "Syaani tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.gray": "Harmaa tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.green": "Vihreä tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Vaaleansininen tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Vaaleanharmaa tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.lime": "Limetinvihreä tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purppura tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranssi tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.pink": "Vaaleanpunainen  tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.purple": "Violetti tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.red": "Punainen tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.white": "Valkoinen tyviövastalohkoinen",
  "block.minecraft.banner.diagonal_up_right.yellow": "Keltainen tyviövastalohkoinen",
  "block.minecraft.banner.flow.black": "Musta virtaus",
  "block.minecraft.banner.flow.blue": "Sininen virtaus",
  "block.minecraft.banner.flow.brown": "Ruskea virtaus",
  "block.minecraft.banner.flow.cyan": "Syaani virtaus",
  "block.minecraft.banner.flow.gray": "Harmaa virtaus",
  "block.minecraft.banner.flow.green": "Vihreä virtaus",
  "block.minecraft.banner.flow.light_blue": "Vaaleansininen virtaus",
  "block.minecraft.banner.flow.light_gray": "Vaaleanharmaa virtaus",
  "block.minecraft.banner.flow.lime": "Limetinvihreä virtaus",
  "block.minecraft.banner.flow.magenta": "Purppura virtaus",
  "block.minecraft.banner.flow.orange": "Oranssi virtaus",
  "block.minecraft.banner.flow.pink": "Vaaleanpunainen virtaus",
  "block.minecraft.banner.flow.purple": "Violetti virtaus",
  "block.minecraft.banner.flow.red": "Punainen virtaus",
  "block.minecraft.banner.flow.white": "Valkoinen virtaus",
  "block.minecraft.banner.flow.yellow": "Keltainen virtaus",
  "block.minecraft.banner.flower.black": "Musta kukka",
  "block.minecraft.banner.flower.blue": "Sininen kukka",
  "block.minecraft.banner.flower.brown": "Ruskea kukka",
  "block.minecraft.banner.flower.cyan": "Syaani kukka",
  "block.minecraft.banner.flower.gray": "Harmaa kukka",
  "block.minecraft.banner.flower.green": "Vihreä kukka",
  "block.minecraft.banner.flower.light_blue": "Vaaleansininen kukka",
  "block.minecraft.banner.flower.light_gray": "Vaaleanharmaa kukka",
  "block.minecraft.banner.flower.lime": "Limetinvihreä kukka",
  "block.minecraft.banner.flower.magenta": "Purppura kukka",
  "block.minecraft.banner.flower.orange": "Oranssi kukka",
  "block.minecraft.banner.flower.pink": "Vaaleanpunainen kukka",
  "block.minecraft.banner.flower.purple": "Violetti kukka",
  "block.minecraft.banner.flower.red": "Punainen kukka",
  "block.minecraft.banner.flower.white": "Valkoinen kukka",
  "block.minecraft.banner.flower.yellow": "Keltainen kukka",
  "block.minecraft.banner.globe.black": "Musta karttakuutio",
  "block.minecraft.banner.globe.blue": "Sininen karttakuutio",
  "block.minecraft.banner.globe.brown": "Ruskea karttakuutio",
  "block.minecraft.banner.globe.cyan": "Syaani karttakuutio",
  "block.minecraft.banner.globe.gray": "Harmaa karttakuutio",
  "block.minecraft.banner.globe.green": "Vihreä karttakuutio",
  "block.minecraft.banner.globe.light_blue": "Vaaleansininen karttakuutio",
  "block.minecraft.banner.globe.light_gray": "Vaaleanharmaa karttakuutio",
  "block.minecraft.banner.globe.lime": "Limetinvihreä karttakuutio",
  "block.minecraft.banner.globe.magenta": "Purppura karttakuutio",
  "block.minecraft.banner.globe.orange": "Oranssi karttakuutio",
  "block.minecraft.banner.globe.pink": "Vaaleanpunainen karttakuutio",
  "block.minecraft.banner.globe.purple": "Violetti karttakuutio",
  "block.minecraft.banner.globe.red": "Punainen karttakuutio",
  "block.minecraft.banner.globe.white": "Valkoinen karttakuutio",
  "block.minecraft.banner.globe.yellow": "Keltainen karttakuutio",
  "block.minecraft.banner.gradient.black": "Musta häivytys alas",
  "block.minecraft.banner.gradient.blue": "Sininen häivytys alas",
  "block.minecraft.banner.gradient.brown": "Ruskea häivytys alas",
  "block.minecraft.banner.gradient.cyan": "Syaani häivytys alas",
  "block.minecraft.banner.gradient.gray": "Harmaa häivytys alas",
  "block.minecraft.banner.gradient.green": "Vihreä häivytys alas",
  "block.minecraft.banner.gradient.light_blue": "Vaaleansininen häivytys alas",
  "block.minecraft.banner.gradient.light_gray": "Vaaleanharmaa häivytys alas",
  "block.minecraft.banner.gradient.lime": "Limetinvihreä häivytys alas",
  "block.minecraft.banner.gradient.magenta": "Purppura häivytys alas",
  "block.minecraft.banner.gradient.orange": "Oranssi häivytys alas",
  "block.minecraft.banner.gradient.pink": "Vaaleanpunainen häivytys alas",
  "block.minecraft.banner.gradient.purple": "Violetti häivytys alas",
  "block.minecraft.banner.gradient.red": "Punainen häivytys alas",
  "block.minecraft.banner.gradient.white": "Valkoinen häivytys alas",
  "block.minecraft.banner.gradient.yellow": "Keltainen häivytys alas",
  "block.minecraft.banner.gradient_up.black": "Musta häivytys ylös",
  "block.minecraft.banner.gradient_up.blue": "Sininen häivytys ylös",
  "block.minecraft.banner.gradient_up.brown": "Ruskea häivytys ylös",
  "block.minecraft.banner.gradient_up.cyan": "Syaani häivytys ylös",
  "block.minecraft.banner.gradient_up.gray": "Harmaa häivytys ylös",
  "block.minecraft.banner.gradient_up.green": "Vihreä häivytys ylös",
  "block.minecraft.banner.gradient_up.light_blue": "Vaaleansininen häivytys ylös",
  "block.minecraft.banner.gradient_up.light_gray": "Vaaleanharmaa häivytys ylös",
  "block.minecraft.banner.gradient_up.lime": "Limetinvihreä häivytys ylös",
  "block.minecraft.banner.gradient_up.magenta": "Purppura häivytys ylös",
  "block.minecraft.banner.gradient_up.orange": "Oranssi häivytys ylös",
  "block.minecraft.banner.gradient_up.pink": "Vaaleanpunainen häivytys ylös",
  "block.minecraft.banner.gradient_up.purple": "Violetti häivytys ylös",
  "block.minecraft.banner.gradient_up.red": "Punainen häivytys ylös",
  "block.minecraft.banner.gradient_up.white": "Valkoinen häivytys ylös",
  "block.minecraft.banner.gradient_up.yellow": "Keltainen häivytys ylös",
  "block.minecraft.banner.guster.black": "Musta tuulahdus",
  "block.minecraft.banner.guster.blue": "Sininen tuulahdus",
  "block.minecraft.banner.guster.brown": "Ruskea tuulahdus",
  "block.minecraft.banner.guster.cyan": "Syaani tuulahdus",
  "block.minecraft.banner.guster.gray": "Harmaa tuulahdus",
  "block.minecraft.banner.guster.green": "Vihreä tuulahdus",
  "block.minecraft.banner.guster.light_blue": "Vaaleansininen tuulahdus",
  "block.minecraft.banner.guster.light_gray": "Vaaleanharmaa tuulahdus",
  "block.minecraft.banner.guster.lime": "Limetinvihreä tuulahdus",
  "block.minecraft.banner.guster.magenta": "Purppura tuulahdus",
  "block.minecraft.banner.guster.orange": "Oranssi tuulahdus",
  "block.minecraft.banner.guster.pink": "Vaaleanpunainen tuulahdus",
  "block.minecraft.banner.guster.purple": "Violetti tuulahdus",
  "block.minecraft.banner.guster.red": "Punainen tuulahdus",
  "block.minecraft.banner.guster.white": "Valkoinen tuulahdus",
  "block.minecraft.banner.guster.yellow": "Keltainen tuulahdus",
  "block.minecraft.banner.half_horizontal.black": "Musta yläpuoli",
  "block.minecraft.banner.half_horizontal.blue": "Sininen yläpuoli",
  "block.minecraft.banner.half_horizontal.brown": "Ruskea yläpuoli",
  "block.minecraft.banner.half_horizontal.cyan": "Syaani yläpuoli",
  "block.minecraft.banner.half_horizontal.gray": "Harmaa yläpuoli",
  "block.minecraft.banner.half_horizontal.green": "Vihreä yläpuoli",
  "block.minecraft.banner.half_horizontal.light_blue": "Vaaleansininen yläpuoli",
  "block.minecraft.banner.half_horizontal.light_gray": "Vaaleanharmaa yläpuoli",
  "block.minecraft.banner.half_horizontal.lime": "Limetinvihreä yläpuoli",
  "block.minecraft.banner.half_horizontal.magenta": "Purppura yläpuoli",
  "block.minecraft.banner.half_horizontal.orange": "Oranssi yläpuoli",
  "block.minecraft.banner.half_horizontal.pink": "Vaaleanpunainen yläpuoli",
  "block.minecraft.banner.half_horizontal.purple": "Violetti yläpuoli",
  "block.minecraft.banner.half_horizontal.red": "Punainen yläpuoli",
  "block.minecraft.banner.half_horizontal.white": "Valkoinen yläpuoli",
  "block.minecraft.banner.half_horizontal.yellow": "Keltainen yläpuoli",
  "block.minecraft.banner.half_horizontal_bottom.black": "Musta alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Sininen alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Ruskea alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Syaani alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Harmaa alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.green": "Vihreä alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Vaaleansininen alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Vaaleanharmaa alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limetinvihreä alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purppura alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranssi alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Vaaleanpunainen alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Violetti alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.red": "Punainen alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.white": "Valkoinen alapuoli",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Keltainen alapuoli",
  "block.minecraft.banner.half_vertical.black": "Musta halkoinen",
  "block.minecraft.banner.half_vertical.blue": "Sininen halkoinen",
  "block.minecraft.banner.half_vertical.brown": "Ruskea halkoinen",
  "block.minecraft.banner.half_vertical.cyan": "Syaani halkoinen",
  "block.minecraft.banner.half_vertical.gray": "Harmaa halkoinen",
  "block.minecraft.banner.half_vertical.green": "Vihreä halkoinen",
  "block.minecraft.banner.half_vertical.light_blue": "Vaaleansininen halkoinen",
  "block.minecraft.banner.half_vertical.light_gray": "Vaaleanharmaa halkoinen",
  "block.minecraft.banner.half_vertical.lime": "Limetinvihreä halkoinen",
  "block.minecraft.banner.half_vertical.magenta": "Purppura halkoinen",
  "block.minecraft.banner.half_vertical.orange": "Oranssi halkoinen",
  "block.minecraft.banner.half_vertical.pink": "Vaaleanpunainen halkoinen",
  "block.minecraft.banner.half_vertical.purple": "Violetti halkoinen",
  "block.minecraft.banner.half_vertical.red": "Punainen halkoinen",
  "block.minecraft.banner.half_vertical.white": "Valkoinen halkoinen",
  "block.minecraft.banner.half_vertical.yellow": "Keltainen halkoinen",
  "block.minecraft.banner.half_vertical_right.black": "Musta vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.blue": "Sininen vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.brown": "Ruskea vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.cyan": "Syaani vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.gray": "Harmaa vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.green": "Vihreä vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.light_blue": "Vaaleansininen vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.light_gray": "Vaaleanharmaa vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.lime": "Limetinvihreä vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.magenta": "Purppura vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.orange": "Oranssi vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.pink": "Vaaleanpunainen vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.purple": "Violetti vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.red": "Punainen vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.white": "Valkoinen vastahalkoinen",
  "block.minecraft.banner.half_vertical_right.yellow": "Keltainen vastahalkoinen",
  "block.minecraft.banner.mojang.black": "Musta Mojang-logo",
  "block.minecraft.banner.mojang.blue": "Sininen Mojang-logo",
  "block.minecraft.banner.mojang.brown": "Ruskea Mojang-logo",
  "block.minecraft.banner.mojang.cyan": "Syaani Mojang-logo",
  "block.minecraft.banner.mojang.gray": "Harmaa Mojang-logo",
  "block.minecraft.banner.mojang.green": "Vihreä Mojang-logo",
  "block.minecraft.banner.mojang.light_blue": "Vaaleansininen Mojang-logo",
  "block.minecraft.banner.mojang.light_gray": "Vaaleanharmaa Mojang-logo",
  "block.minecraft.banner.mojang.lime": "Limetinvihreä Mojang-logo",
  "block.minecraft.banner.mojang.magenta": "Purppura Mojang-logo",
  "block.minecraft.banner.mojang.orange": "Oranssi Mojang-logo",
  "block.minecraft.banner.mojang.pink": "Vaaleanpunainen Mojang-logo",
  "block.minecraft.banner.mojang.purple": "Violetti Mojang-logo",
  "block.minecraft.banner.mojang.red": "Punainen Mojang-logo",
  "block.minecraft.banner.mojang.white": "Valkoinen Mojang-logo",
  "block.minecraft.banner.mojang.yellow": "Keltainen Mojang-logo",
  "block.minecraft.banner.piglin.black": "Musta kärsä",
  "block.minecraft.banner.piglin.blue": "Sininen kärsä",
  "block.minecraft.banner.piglin.brown": "Ruskea kärsä",
  "block.minecraft.banner.piglin.cyan": "Syaani kärsä",
  "block.minecraft.banner.piglin.gray": "Harmaa kärsä",
  "block.minecraft.banner.piglin.green": "Vihreä kärsä",
  "block.minecraft.banner.piglin.light_blue": "Vaaleansininen kärsä",
  "block.minecraft.banner.piglin.light_gray": "Vaaleanharmaa kärsä",
  "block.minecraft.banner.piglin.lime": "Limetinvihreä kärsä",
  "block.minecraft.banner.piglin.magenta": "Purppura kärsä",
  "block.minecraft.banner.piglin.orange": "Oranssi kärsä",
  "block.minecraft.banner.piglin.pink": "Vaaleanpunainen kärsä",
  "block.minecraft.banner.piglin.purple": "Violetti kärsä",
  "block.minecraft.banner.piglin.red": "Punainen kärsä",
  "block.minecraft.banner.piglin.white": "Valkoinen kärsä",
  "block.minecraft.banner.piglin.yellow": "Keltainen kärsä",
  "block.minecraft.banner.rhombus.black": "Musta ruutu",
  "block.minecraft.banner.rhombus.blue": "Sininen ruutu",
  "block.minecraft.banner.rhombus.brown": "Ruskea ruutu",
  "block.minecraft.banner.rhombus.cyan": "Syaani ruutu",
  "block.minecraft.banner.rhombus.gray": "Harmaa ruutu",
  "block.minecraft.banner.rhombus.green": "Vihreä ruutu",
  "block.minecraft.banner.rhombus.light_blue": "Vaaleansininen ruutu",
  "block.minecraft.banner.rhombus.light_gray": "Vaaleanharmaa ruutu",
  "block.minecraft.banner.rhombus.lime": "Limetinvihreä ruutu",
  "block.minecraft.banner.rhombus.magenta": "Purppura ruutu",
  "block.minecraft.banner.rhombus.orange": "Oranssi ruutu",
  "block.minecraft.banner.rhombus.pink": "Vaaleanpunainen ruutu",
  "block.minecraft.banner.rhombus.purple": "Violetti ruutu",
  "block.minecraft.banner.rhombus.red": "Punainen ruutu",
  "block.minecraft.banner.rhombus.white": "Valkoinen ruutu",
  "block.minecraft.banner.rhombus.yellow": "Keltainen ruutu",
  "block.minecraft.banner.skull.black": "Musta pääkallo",
  "block.minecraft.banner.skull.blue": "Sininen pääkallo",
  "block.minecraft.banner.skull.brown": "Ruskea pääkallo",
  "block.minecraft.banner.skull.cyan": "Syaani pääkallo",
  "block.minecraft.banner.skull.gray": "Harmaa pääkallo",
  "block.minecraft.banner.skull.green": "Vihreä pääkallo",
  "block.minecraft.banner.skull.light_blue": "Vaaleansininen pääkallo",
  "block.minecraft.banner.skull.light_gray": "Vaaleanharmaa pääkallo",
  "block.minecraft.banner.skull.lime": "Limetinvihreä pääkallo",
  "block.minecraft.banner.skull.magenta": "Purppura pääkallo",
  "block.minecraft.banner.skull.orange": "Oranssi pääkallo",
  "block.minecraft.banner.skull.pink": "Vaaleanpunainen pääkallo",
  "block.minecraft.banner.skull.purple": "Violetti pääkallo",
  "block.minecraft.banner.skull.red": "Punainen pääkallo",
  "block.minecraft.banner.skull.white": "Valkoinen pääkallo",
  "block.minecraft.banner.skull.yellow": "Keltainen pääkallo",
  "block.minecraft.banner.small_stripes.black": "Musta paalu",
  "block.minecraft.banner.small_stripes.blue": "Sininen paalu",
  "block.minecraft.banner.small_stripes.brown": "Ruskea paalu",
  "block.minecraft.banner.small_stripes.cyan": "Syaani paalu",
  "block.minecraft.banner.small_stripes.gray": "Harmaa paalu",
  "block.minecraft.banner.small_stripes.green": "Vihreä paalu",
  "block.minecraft.banner.small_stripes.light_blue": "Vaaleansininen paalu",
  "block.minecraft.banner.small_stripes.light_gray": "Vaaleanharmaa paalu",
  "block.minecraft.banner.small_stripes.lime": "Limetinvihreä paalu",
  "block.minecraft.banner.small_stripes.magenta": "Purppura paalu",
  "block.minecraft.banner.small_stripes.orange": "Oranssi paalu",
  "block.minecraft.banner.small_stripes.pink": "Vaaleanpunainen paalu",
  "block.minecraft.banner.small_stripes.purple": "Violetti paalu",
  "block.minecraft.banner.small_stripes.red": "Punainen paalu",
  "block.minecraft.banner.small_stripes.white": "Valkoinen paalu",
  "block.minecraft.banner.small_stripes.yellow": "Keltainen paalu",
  "block.minecraft.banner.square_bottom_left.black": "Musta vasen alakulma",
  "block.minecraft.banner.square_bottom_left.blue": "Sininen vasen alakulma",
  "block.minecraft.banner.square_bottom_left.brown": "Ruskea vasen alakulma",
  "block.minecraft.banner.square_bottom_left.cyan": "Syaani vasen alakulma",
  "block.minecraft.banner.square_bottom_left.gray": "Harmaa vasen alakulma",
  "block.minecraft.banner.square_bottom_left.green": "Vihreä vasen alakulma",
  "block.minecraft.banner.square_bottom_left.light_blue": "Vaaleansininen vasen alakulma",
  "block.minecraft.banner.square_bottom_left.light_gray": "Vaaleanharmaa vasen alakulma",
  "block.minecraft.banner.square_bottom_left.lime": "Limetinvihreä vasen alakulma",
  "block.minecraft.banner.square_bottom_left.magenta": "Purppura vasen alakulma",
  "block.minecraft.banner.square_bottom_left.orange": "Oranssi vasen alakulma",
  "block.minecraft.banner.square_bottom_left.pink": "Vaaleanpunainen vasen alakulma",
  "block.minecraft.banner.square_bottom_left.purple": "Violetti vasen alakulma",
  "block.minecraft.banner.square_bottom_left.red": "Punainen vasen alakulma",
  "block.minecraft.banner.square_bottom_left.white": "Valkoinen vasen alakulma",
  "block.minecraft.banner.square_bottom_left.yellow": "Keltainen vasen alakulma",
  "block.minecraft.banner.square_bottom_right.black": "Musta oikea alakulma",
  "block.minecraft.banner.square_bottom_right.blue": "Sininen oikea alakulma",
  "block.minecraft.banner.square_bottom_right.brown": "Ruskea oikea alakulma",
  "block.minecraft.banner.square_bottom_right.cyan": "Syaani oikea alakulma",
  "block.minecraft.banner.square_bottom_right.gray": "Harmaa oikea alakulma",
  "block.minecraft.banner.square_bottom_right.green": "Vihreä oikea alakulma",
  "block.minecraft.banner.square_bottom_right.light_blue": "Vaaleansininen oikea alakulma",
  "block.minecraft.banner.square_bottom_right.light_gray": "Vaaleanharmaa oikea alakulma",
  "block.minecraft.banner.square_bottom_right.lime": "Limetinvihreä oikea alakulma",
  "block.minecraft.banner.square_bottom_right.magenta": "Purppura oikea alakulma",
  "block.minecraft.banner.square_bottom_right.orange": "Oranssi oikea alakulma",
  "block.minecraft.banner.square_bottom_right.pink": "Vaaleanpunainen oikea alakulma",
  "block.minecraft.banner.square_bottom_right.purple": "Violetti oikea alakulma",
  "block.minecraft.banner.square_bottom_right.red": "Punainen oikea alakulma",
  "block.minecraft.banner.square_bottom_right.white": "Valkoinen oikea alakulma",
  "block.minecraft.banner.square_bottom_right.yellow": "Keltainen oikea alakulma",
  "block.minecraft.banner.square_top_left.black": "Musta vasen yläkulma",
  "block.minecraft.banner.square_top_left.blue": "Sininen vasen yläkulma",
  "block.minecraft.banner.square_top_left.brown": "Ruskea vasen yläkulma",
  "block.minecraft.banner.square_top_left.cyan": "Syaani vasen yläkulma",
  "block.minecraft.banner.square_top_left.gray": "Harmaa vasen yläkulma",
  "block.minecraft.banner.square_top_left.green": "Vihreä vasen yläkulma",
  "block.minecraft.banner.square_top_left.light_blue": "Vaaleansininen vasen yläkulma",
  "block.minecraft.banner.square_top_left.light_gray": "Vaaleanharmaa vasen yläkulma",
  "block.minecraft.banner.square_top_left.lime": "Limetinvihreä vasen yläkulma",
  "block.minecraft.banner.square_top_left.magenta": "Purppura vasen yläkulma",
  "block.minecraft.banner.square_top_left.orange": "Oranssi vasen yläkulma",
  "block.minecraft.banner.square_top_left.pink": "Vaaleanpunainen vasen yläkulma",
  "block.minecraft.banner.square_top_left.purple": "Violetti vasen yläkulma",
  "block.minecraft.banner.square_top_left.red": "Punainen vasen yläkulma",
  "block.minecraft.banner.square_top_left.white": "Valkoinen vasen yläkulma",
  "block.minecraft.banner.square_top_left.yellow": "Keltainen vasen yläkulma",
  "block.minecraft.banner.square_top_right.black": "Musta oikea yläkulma",
  "block.minecraft.banner.square_top_right.blue": "Sininen oikea yläkulma",
  "block.minecraft.banner.square_top_right.brown": "Ruskea oikea yläkulma",
  "block.minecraft.banner.square_top_right.cyan": "Syaani oikea yläkulma",
  "block.minecraft.banner.square_top_right.gray": "Harmaa oikea yläkulma",
  "block.minecraft.banner.square_top_right.green": "Vihreä oikea yläkulma",
  "block.minecraft.banner.square_top_right.light_blue": "Vaaleansininen oikea yläkulma",
  "block.minecraft.banner.square_top_right.light_gray": "Vaaleanharmaa oikea yläkulma",
  "block.minecraft.banner.square_top_right.lime": "Limetinvihreä oikea yläkulma",
  "block.minecraft.banner.square_top_right.magenta": "Purppura oikea yläkulma",
  "block.minecraft.banner.square_top_right.orange": "Oranssi oikea yläkulma",
  "block.minecraft.banner.square_top_right.pink": "Vaaleanpunainen oikea yläkulma",
  "block.minecraft.banner.square_top_right.purple": "Violetti oikea yläkulma",
  "block.minecraft.banner.square_top_right.red": "Punainen oikea yläkulma",
  "block.minecraft.banner.square_top_right.white": "Valkoinen oikea yläkulma",
  "block.minecraft.banner.square_top_right.yellow": "Keltainen oikea yläkulma",
  "block.minecraft.banner.straight_cross.black": "Musta risti",
  "block.minecraft.banner.straight_cross.blue": "Sininen risti",
  "block.minecraft.banner.straight_cross.brown": "Ruskea risti",
  "block.minecraft.banner.straight_cross.cyan": "Syaani risti",
  "block.minecraft.banner.straight_cross.gray": "Harmaa risti",
  "block.minecraft.banner.straight_cross.green": "Vihreä risti",
  "block.minecraft.banner.straight_cross.light_blue": "Vaaleansininen risti",
  "block.minecraft.banner.straight_cross.light_gray": "Vaaleanharmaa risti",
  "block.minecraft.banner.straight_cross.lime": "Limetinvihreä risti",
  "block.minecraft.banner.straight_cross.magenta": "Purppura risti",
  "block.minecraft.banner.straight_cross.orange": "Oranssi risti",
  "block.minecraft.banner.straight_cross.pink": "Vaaleanpunainen risti",
  "block.minecraft.banner.straight_cross.purple": "Violetti risti",
  "block.minecraft.banner.straight_cross.red": "Punainen risti",
  "block.minecraft.banner.straight_cross.white": "Valkoinen risti",
  "block.minecraft.banner.straight_cross.yellow": "Keltainen risti",
  "block.minecraft.banner.stripe_bottom.black": "Musta tyviö",
  "block.minecraft.banner.stripe_bottom.blue": "Sininen tyviö",
  "block.minecraft.banner.stripe_bottom.brown": "Ruskea tyviö",
  "block.minecraft.banner.stripe_bottom.cyan": "Syaani tyviö",
  "block.minecraft.banner.stripe_bottom.gray": "Harmaa tyviö",
  "block.minecraft.banner.stripe_bottom.green": "Vihreä tyviö",
  "block.minecraft.banner.stripe_bottom.light_blue": "Vaaleansininen tyviö",
  "block.minecraft.banner.stripe_bottom.light_gray": "Vaaleanharmaa tyviö",
  "block.minecraft.banner.stripe_bottom.lime": "Limetinvihreä tyviö",
  "block.minecraft.banner.stripe_bottom.magenta": "Purppura tyviö",
  "block.minecraft.banner.stripe_bottom.orange": "Oranssi tyviö",
  "block.minecraft.banner.stripe_bottom.pink": "Vaaleanpunainen tyviö",
  "block.minecraft.banner.stripe_bottom.purple": "Violetti tyviö",
  "block.minecraft.banner.stripe_bottom.red": "Punainen tyviö",
  "block.minecraft.banner.stripe_bottom.white": "Valkoinen tyviö",
  "block.minecraft.banner.stripe_bottom.yellow": "Keltainen tyviö",
  "block.minecraft.banner.stripe_center.black": "Musta pystyraita",
  "block.minecraft.banner.stripe_center.blue": "Sininen pystyraita",
  "block.minecraft.banner.stripe_center.brown": "Ruskea pystyraita",
  "block.minecraft.banner.stripe_center.cyan": "Syaani pystyraita",
  "block.minecraft.banner.stripe_center.gray": "Harmaa pystyraita",
  "block.minecraft.banner.stripe_center.green": "Vihreä pystyraita",
  "block.minecraft.banner.stripe_center.light_blue": "Vaaleansininen pystyraita",
  "block.minecraft.banner.stripe_center.light_gray": "Vaaleanharmaa pystyraita",
  "block.minecraft.banner.stripe_center.lime": "Limetinvihreä pystyraita",
  "block.minecraft.banner.stripe_center.magenta": "Purppura pystyraita",
  "block.minecraft.banner.stripe_center.orange": "Oranssi pystyraita",
  "block.minecraft.banner.stripe_center.pink": "Vaaleanpunainen pystyraita",
  "block.minecraft.banner.stripe_center.purple": "Violetti pystyraita",
  "block.minecraft.banner.stripe_center.red": "Punainen pystyraita",
  "block.minecraft.banner.stripe_center.white": "Valkoinen pystyraita",
  "block.minecraft.banner.stripe_center.yellow": "Keltainen pystyraita",
  "block.minecraft.banner.stripe_downleft.black": "Musta vastapalkki",
  "block.minecraft.banner.stripe_downleft.blue": "Sininen vastapalkki",
  "block.minecraft.banner.stripe_downleft.brown": "Ruskea vastapalkki",
  "block.minecraft.banner.stripe_downleft.cyan": "Syaani vastapalkki",
  "block.minecraft.banner.stripe_downleft.gray": "Harmaa vastapalkki",
  "block.minecraft.banner.stripe_downleft.green": "Vihreä vastapalkki",
  "block.minecraft.banner.stripe_downleft.light_blue": "Vaaleansinen vastapalkki",
  "block.minecraft.banner.stripe_downleft.light_gray": "Vaaleanharmaa vastapalkki",
  "block.minecraft.banner.stripe_downleft.lime": "Limetinvihreä vastapalkki",
  "block.minecraft.banner.stripe_downleft.magenta": "Purppura vastapalkki",
  "block.minecraft.banner.stripe_downleft.orange": "Oranssi vastapalkki",
  "block.minecraft.banner.stripe_downleft.pink": "Vaaleanpunainen vastapalkki",
  "block.minecraft.banner.stripe_downleft.purple": "Violetti vastapalkki",
  "block.minecraft.banner.stripe_downleft.red": "Punainen vastapalkki",
  "block.minecraft.banner.stripe_downleft.white": "Valkoinen vastapalkki",
  "block.minecraft.banner.stripe_downleft.yellow": "Keltainen vastapalkki",
  "block.minecraft.banner.stripe_downright.black": "Musta palkki",
  "block.minecraft.banner.stripe_downright.blue": "Sininen palkki",
  "block.minecraft.banner.stripe_downright.brown": "Ruskea palkki",
  "block.minecraft.banner.stripe_downright.cyan": "Syaani palkki",
  "block.minecraft.banner.stripe_downright.gray": "Harmaa palkki",
  "block.minecraft.banner.stripe_downright.green": "Vihreä palkki",
  "block.minecraft.banner.stripe_downright.light_blue": "Vaaleansininen palkki",
  "block.minecraft.banner.stripe_downright.light_gray": "Vaaleanharmaa palkki",
  "block.minecraft.banner.stripe_downright.lime": "Limetinvihreä palkki",
  "block.minecraft.banner.stripe_downright.magenta": "Purppura palkki",
  "block.minecraft.banner.stripe_downright.orange": "Oranssi palkki",
  "block.minecraft.banner.stripe_downright.pink": "Vaaleanpunainen palkki",
  "block.minecraft.banner.stripe_downright.purple": "Violetti palkki",
  "block.minecraft.banner.stripe_downright.red": "Punainen palkki",
  "block.minecraft.banner.stripe_downright.white": "Valkoinen palkki",
  "block.minecraft.banner.stripe_downright.yellow": "Keltainen palkki",
  "block.minecraft.banner.stripe_left.black": "Musta vasen reuna",
  "block.minecraft.banner.stripe_left.blue": "Sininen vasen reuna",
  "block.minecraft.banner.stripe_left.brown": "Ruskea vasen reuna",
  "block.minecraft.banner.stripe_left.cyan": "Syaani vasen reuna",
  "block.minecraft.banner.stripe_left.gray": "Harmaa vasen reuna",
  "block.minecraft.banner.stripe_left.green": "Vihreä vasen reuna",
  "block.minecraft.banner.stripe_left.light_blue": "Vaaleansininen vasen reuna",
  "block.minecraft.banner.stripe_left.light_gray": "Vaaleanharmaa vasen reuna",
  "block.minecraft.banner.stripe_left.lime": "Limetinvihreä vasen reuna",
  "block.minecraft.banner.stripe_left.magenta": "Purppura vasen reuna",
  "block.minecraft.banner.stripe_left.orange": "Oranssi vasen reuna",
  "block.minecraft.banner.stripe_left.pink": "Vaaleanpunainen vasen reuna",
  "block.minecraft.banner.stripe_left.purple": "Violetti vasen reuna",
  "block.minecraft.banner.stripe_left.red": "Punainen vasen reuna",
  "block.minecraft.banner.stripe_left.white": "Valkoinen vasen reuna",
  "block.minecraft.banner.stripe_left.yellow": "Keltainen vasen reuna",
  "block.minecraft.banner.stripe_middle.black": "Musta vaakaraita",
  "block.minecraft.banner.stripe_middle.blue": "Sininen vaakaraita",
  "block.minecraft.banner.stripe_middle.brown": "Ruskea vaakaraita",
  "block.minecraft.banner.stripe_middle.cyan": "Syaani vaakaraita",
  "block.minecraft.banner.stripe_middle.gray": "Harmaa vaakaraita",
  "block.minecraft.banner.stripe_middle.green": "Vihreä vaakaraita",
  "block.minecraft.banner.stripe_middle.light_blue": "Vaaleansininen vaakaraita",
  "block.minecraft.banner.stripe_middle.light_gray": "Vaaleanharmaa vaakaraita",
  "block.minecraft.banner.stripe_middle.lime": "Limetinvihreä vaakaraita",
  "block.minecraft.banner.stripe_middle.magenta": "Purppura vaakaraita",
  "block.minecraft.banner.stripe_middle.orange": "Oranssi vaakaraita",
  "block.minecraft.banner.stripe_middle.pink": "Vaaleanpunainen vaakaraita",
  "block.minecraft.banner.stripe_middle.purple": "Violetti vaakaraita",
  "block.minecraft.banner.stripe_middle.red": "Punainen vaakaraita",
  "block.minecraft.banner.stripe_middle.white": "Valkoinen vaakaraita",
  "block.minecraft.banner.stripe_middle.yellow": "Keltainen vaakaraita",
  "block.minecraft.banner.stripe_right.black": "Musta oikea reuna",
  "block.minecraft.banner.stripe_right.blue": "Sininen oikea reuna",
  "block.minecraft.banner.stripe_right.brown": "Ruskea oikea reuna",
  "block.minecraft.banner.stripe_right.cyan": "Syaani oikea reuna",
  "block.minecraft.banner.stripe_right.gray": "Harmaa oikea reuna",
  "block.minecraft.banner.stripe_right.green": "Vihreä oikea reuna",
  "block.minecraft.banner.stripe_right.light_blue": "Vaaleansininen oikea reuna",
  "block.minecraft.banner.stripe_right.light_gray": "Vaaleanharmaa oikea reuna",
  "block.minecraft.banner.stripe_right.lime": "Limetinvihreä oikea reuna",
  "block.minecraft.banner.stripe_right.magenta": "Purppura oikea reuna",
  "block.minecraft.banner.stripe_right.orange": "Oranssi oikea reuna",
  "block.minecraft.banner.stripe_right.pink": "Vaaleanpunainen oikea reuna",
  "block.minecraft.banner.stripe_right.purple": "Violetti oikea reuna",
  "block.minecraft.banner.stripe_right.red": "Punainen oikea reuna",
  "block.minecraft.banner.stripe_right.white": "Valkoinen oikea reuna",
  "block.minecraft.banner.stripe_right.yellow": "Keltainen oikea reuna",
  "block.minecraft.banner.stripe_top.black": "Musta lakio",
  "block.minecraft.banner.stripe_top.blue": "Sininen lakio",
  "block.minecraft.banner.stripe_top.brown": "Ruskea lakio",
  "block.minecraft.banner.stripe_top.cyan": "Syaani lakio",
  "block.minecraft.banner.stripe_top.gray": "Harmaa lakio",
  "block.minecraft.banner.stripe_top.green": "Vihreä lakio",
  "block.minecraft.banner.stripe_top.light_blue": "Vaaleansininen lakio",
  "block.minecraft.banner.stripe_top.light_gray": "Vaaleanharmaa lakio",
  "block.minecraft.banner.stripe_top.lime": "Limetinvihreä lakio",
  "block.minecraft.banner.stripe_top.magenta": "Purppura lakio",
  "block.minecraft.banner.stripe_top.orange": "Oranssi lakio",
  "block.minecraft.banner.stripe_top.pink": "Vaaleanpunainen lakio",
  "block.minecraft.banner.stripe_top.purple": "Violetti lakio",
  "block.minecraft.banner.stripe_top.red": "Punainen lakio",
  "block.minecraft.banner.stripe_top.white": "Valkoinen lakio",
  "block.minecraft.banner.stripe_top.yellow": "Keltainen lakio",
  "block.minecraft.banner.triangle_bottom.black": "Musta polviorsi",
  "block.minecraft.banner.triangle_bottom.blue": "Sininen polviorsi",
  "block.minecraft.banner.triangle_bottom.brown": "Ruskea polviorsi",
  "block.minecraft.banner.triangle_bottom.cyan": "Syaani polviorsi",
  "block.minecraft.banner.triangle_bottom.gray": "Harmaa polviorsi",
  "block.minecraft.banner.triangle_bottom.green": "Vihreä polviorsi",
  "block.minecraft.banner.triangle_bottom.light_blue": "Vaaleansininen polviorsi",
  "block.minecraft.banner.triangle_bottom.light_gray": "Vaaleanharmaa polviorsi",
  "block.minecraft.banner.triangle_bottom.lime": "Limetinvihreä polviorsi",
  "block.minecraft.banner.triangle_bottom.magenta": "Purppura polviorsi",
  "block.minecraft.banner.triangle_bottom.orange": "Oranssi polviorsi",
  "block.minecraft.banner.triangle_bottom.pink": "Vaaleanpunainen polviorsi",
  "block.minecraft.banner.triangle_bottom.purple": "Violetti polviorsi",
  "block.minecraft.banner.triangle_bottom.red": "Punainen polviorsi",
  "block.minecraft.banner.triangle_bottom.white": "Valkoinen polviorsi",
  "block.minecraft.banner.triangle_bottom.yellow": "Keltainen polviorsi",
  "block.minecraft.banner.triangle_top.black": "Musta kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.blue": "Sininen kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.brown": "Ruskea kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.cyan": "Syaani kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.gray": "Harmaa kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.green": "Vihreä kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.light_blue": "Vaaleansininen kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.light_gray": "Vaaleanharmaa kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.lime": "Limetinvihreä kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.magenta": "Purppura kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.orange": "Oranssi kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.pink": "Vaaleanpunainen kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.purple": "Violetti kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.red": "Punainen kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.white": "Valkoinen kaateinen polviorsi",
  "block.minecraft.banner.triangle_top.yellow": "Keltainen kaateinen polviorsi",
  "block.minecraft.banner.triangles_bottom.black": "Musta hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.blue": "Sininen hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.brown": "Ruskea hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.cyan": "Syaani hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.gray": "Harmaa hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.green": "Vihreä hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.light_blue": "Vaaleansininen hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.light_gray": "Vaaleanharmaa hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.lime": "Limetinvihreä hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.magenta": "Purppura hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.orange": "Oranssi hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.pink": "Vaaleanpunainen hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.purple": "Violetti hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.red": "Punainen hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.white": "Valkoinen hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_bottom.yellow": "Keltainen hammaskoroinen tyviö",
  "block.minecraft.banner.triangles_top.black": "Musta hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.blue": "Sininen hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.brown": "Ruskea hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.cyan": "Syaani hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.gray": "Harmaa hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.green": "Vihreä hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.light_blue": "Vaaleansininen hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.light_gray": "Vaaleanharmaa hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.lime": "Limetinvihreä hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.magenta": "Purppura hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.orange": "Oranssi hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.pink": "Vaaleanpunainen hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.purple": "Violetti hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.red": "Punainen hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.white": "Valkoinen hammaskoroinen lakio",
  "block.minecraft.banner.triangles_top.yellow": "Keltainen hammaskoroinen lakio",
  "block.minecraft.barrel": "Tynnyri",
  "block.minecraft.barrier": "Este",
  "block.minecraft.basalt": "Basaltti",
  "block.minecraft.beacon": "Merkkivalo",
  "block.minecraft.beacon.primary": "Ensisijainen voima",
  "block.minecraft.beacon.secondary": "Toissijainen voima",
  "block.minecraft.bed.no_sleep": "Voit nukkua vain öisin ja ukkosmyrskyjen aikana",
  "block.minecraft.bed.not_safe": "Et voi levätä nyt; lähistöllä on hirviöitä",
  "block.minecraft.bed.obstructed": "Tämä sänky on estetty",
  "block.minecraft.bed.occupied": "Tämä sänky on varattu",
  "block.minecraft.bed.too_far_away": "Et voi levätä nyt; sänky on liian kaukana",
  "block.minecraft.bedrock": "Peruskallio",
  "block.minecraft.bee_nest": "Luonnollinen mehiläispesä",
  "block.minecraft.beehive": "Keinotekoinen mehiläispesä",
  "block.minecraft.beetroots": "Punajuuri",
  "block.minecraft.bell": "Soittokello",
  "block.minecraft.big_dripleaf": "Iso tippulehti",
  "block.minecraft.big_dripleaf_stem": "Iso tippulehtivarsi",
  "block.minecraft.birch_button": "Koivunappi",
  "block.minecraft.birch_door": "Koivuovi",
  "block.minecraft.birch_fence": "Koivuaita",
  "block.minecraft.birch_fence_gate": "Koivuportti",
  "block.minecraft.birch_hanging_sign": "Roikkuva koivukyltti",
  "block.minecraft.birch_leaves": "Koivunlehdet",
  "block.minecraft.birch_log": "Koivuhalko",
  "block.minecraft.birch_planks": "Koivulankut",
  "block.minecraft.birch_pressure_plate": "Koivupainelaatta",
  "block.minecraft.birch_sapling": "Koivun taimi",
  "block.minecraft.birch_shelf": "Koivuhylly",
  "block.minecraft.birch_sign": "Koivukyltti",
  "block.minecraft.birch_slab": "Koivulaatta",
  "block.minecraft.birch_stairs": "Koivuportaat",
  "block.minecraft.birch_trapdoor": "Koivuluukku",
  "block.minecraft.birch_wall_hanging_sign": "Riippuva koivukyltti",
  "block.minecraft.birch_wall_sign": "Ripustettu koivukyltti",
  "block.minecraft.birch_wood": "Koivupuu",
  "block.minecraft.black_banner": "Musta viiri",
  "block.minecraft.black_bed": "Musta sänky",
  "block.minecraft.black_candle": "Musta kynttilä",
  "block.minecraft.black_candle_cake": "Kakku mustalla kynttilällä",
  "block.minecraft.black_carpet": "Musta matto",
  "block.minecraft.black_concrete": "Musta betoni",
  "block.minecraft.black_concrete_powder": "Musta betonijauhe",
  "block.minecraft.black_glazed_terracotta": "Musta lasitettu terrakotta",
  "block.minecraft.black_shulker_box": "Musta shulker-laatikko",
  "block.minecraft.black_stained_glass": "Musta lasi",
  "block.minecraft.black_stained_glass_pane": "Musta lasipaneeli",
  "block.minecraft.black_terracotta": "Musta terrakotta",
  "block.minecraft.black_wool": "Musta villa",
  "block.minecraft.blackstone": "Mustakivi",
  "block.minecraft.blackstone_slab": "Mustakivilaatta",
  "block.minecraft.blackstone_stairs": "Mustakiviportaat",
  "block.minecraft.blackstone_wall": "Mustakivimuuri",
  "block.minecraft.blast_furnace": "Masuuni",
  "block.minecraft.blue_banner": "Sininen viiri",
  "block.minecraft.blue_bed": "Sininen sänky",
  "block.minecraft.blue_candle": "Sininen kynttilä",
  "block.minecraft.blue_candle_cake": "Kakku sinisellä kynttilällä",
  "block.minecraft.blue_carpet": "Sininen matto",
  "block.minecraft.blue_concrete": "Sininen betoni",
  "block.minecraft.blue_concrete_powder": "Sininen betonijauhe",
  "block.minecraft.blue_glazed_terracotta": "Sininen lasitettu terrakotta",
  "block.minecraft.blue_ice": "Sininen jää",
  "block.minecraft.blue_orchid": "Sininen orkidea",
  "block.minecraft.blue_shulker_box": "Sininen shulker-laatikko",
  "block.minecraft.blue_stained_glass": "Sininen lasi",
  "block.minecraft.blue_stained_glass_pane": "Sininen lasipaneeli",
  "block.minecraft.blue_terracotta": "Sininen terrakotta",
  "block.minecraft.blue_wool": "Sininen villa",
  "block.minecraft.bone_block": "Luukuutio",
  "block.minecraft.bookshelf": "Kirjahylly",
  "block.minecraft.brain_coral": "Aivokoralli",
  "block.minecraft.brain_coral_block": "Aivokorallikuutio",
  "block.minecraft.brain_coral_fan": "Aivokoralliviuhka",
  "block.minecraft.brain_coral_wall_fan": "Seinäaivokoralliviuhka",
  "block.minecraft.brewing_stand": "Hautumateline",
  "block.minecraft.brick_slab": "Tiililaatta",
  "block.minecraft.brick_stairs": "Tiiliportaat",
  "block.minecraft.brick_wall": "Tiilimuuri",
  "block.minecraft.bricks": "Tiilet",
  "block.minecraft.brown_banner": "Ruskea viiri",
  "block.minecraft.brown_bed": "Ruskea sänky",
  "block.minecraft.brown_candle": "Ruskea kynttilä",
  "block.minecraft.brown_candle_cake": "Kakku ruskealla kynttilällä",
  "block.minecraft.brown_carpet": "Ruskea matto",
  "block.minecraft.brown_concrete": "Ruskea betoni",
  "block.minecraft.brown_concrete_powder": "Ruskea betonijauhe",
  "block.minecraft.brown_glazed_terracotta": "Ruskea lasitettu terrakotta",
  "block.minecraft.brown_mushroom": "Ruskea sieni",
  "block.minecraft.brown_mushroom_block": "Ruskea sienikuutio",
  "block.minecraft.brown_shulker_box": "Ruskea shulker-laatikko",
  "block.minecraft.brown_stained_glass": "Ruskea lasi",
  "block.minecraft.brown_stained_glass_pane": "Ruskea lasipaneeli",
  "block.minecraft.brown_terracotta": "Ruskea terrakotta",
  "block.minecraft.brown_wool": "Ruskea villa",
  "block.minecraft.bubble_column": "Kuplapylväs",
  "block.minecraft.bubble_coral": "Kuplakoralli",
  "block.minecraft.bubble_coral_block": "Kuplakorallikuutio",
  "block.minecraft.bubble_coral_fan": "Kuplakoralliviuhka",
  "block.minecraft.bubble_coral_wall_fan": "Seinäkuplakoralliviuhka",
  "block.minecraft.budding_amethyst": "Versoava ametisti",
  "block.minecraft.bush": "Pensas",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktuksen kukka",
  "block.minecraft.cake": "Kakku",
  "block.minecraft.calcite": "Kalsiitti",
  "block.minecraft.calibrated_sculk_sensor": "Kalibroitu sculk-sensori",
  "block.minecraft.campfire": "Nuotio",
  "block.minecraft.candle": "Kynttilä",
  "block.minecraft.candle_cake": "Kynttiläkakku",
  "block.minecraft.carrots": "Porkkana",
  "block.minecraft.cartography_table": "Karttapöytä",
  "block.minecraft.carved_pumpkin": "Kaiverrettu kurpitsa",
  "block.minecraft.cauldron": "Pata",
  "block.minecraft.cave_air": "Luolailma",
  "block.minecraft.cave_vines": "Luolaköynnös",
  "block.minecraft.cave_vines_plant": "Luolaköynnöskasvi",
  "block.minecraft.chain": "Ketju",
  "block.minecraft.chain_command_block": "Sarjakomentokuutio",
  "block.minecraft.cherry_button": "Kirsikkapuunappi",
  "block.minecraft.cherry_door": "Kirsikkapuuovi",
  "block.minecraft.cherry_fence": "Kirsikkapuuaita",
  "block.minecraft.cherry_fence_gate": "Kirsikkapuuportti",
  "block.minecraft.cherry_hanging_sign": "Roikkuva kirsikkapuukyltti",
  "block.minecraft.cherry_leaves": "Kirsikkapuun lehdet",
  "block.minecraft.cherry_log": "Kirsikkapuuhalko",
  "block.minecraft.cherry_planks": "Kirsikkapuulankut",
  "block.minecraft.cherry_pressure_plate": "Kirsikkapuupainelaatta",
  "block.minecraft.cherry_sapling": "Kirsikkapuun taimi",
  "block.minecraft.cherry_shelf": "Kirsikkapuuhylly",
  "block.minecraft.cherry_sign": "Kirsikkapuukyltti",
  "block.minecraft.cherry_slab": "Kirsikkapuulaatta",
  "block.minecraft.cherry_stairs": "Kirsikkapuuportaat",
  "block.minecraft.cherry_trapdoor": "Kirsikkapuuluukku",
  "block.minecraft.cherry_wall_hanging_sign": "Riippuva kirsikkapuukyltti",
  "block.minecraft.cherry_wall_sign": "Ripustettu kirsikkapuukyltti",
  "block.minecraft.cherry_wood": "Kirsikkapuu",
  "block.minecraft.chest": "Arkku",
  "block.minecraft.chipped_anvil": "Kolhiintunut alasin",
  "block.minecraft.chiseled_bookshelf": "Täytettävä kirjahylly",
  "block.minecraft.chiseled_copper": "Kaiverrettu kupari",
  "block.minecraft.chiseled_deepslate": "Kaiverrettu pohjaliuskekivi",
  "block.minecraft.chiseled_nether_bricks": "Kaiverretut Nether-tiilet",
  "block.minecraft.chiseled_polished_blackstone": "Kaiverrettu kiillotettu mustakivi",
  "block.minecraft.chiseled_quartz_block": "Kaiverrettu kvartsikuutio",
  "block.minecraft.chiseled_red_sandstone": "Kaiverrettu punahiekkakivi",
  "block.minecraft.chiseled_resin_bricks": "Kaiverretut pihkatiilet",
  "block.minecraft.chiseled_sandstone": "Kaiverrettu hiekkakivi",
  "block.minecraft.chiseled_stone_bricks": "Kaiverretut kivitiilet",
  "block.minecraft.chiseled_tuff": "Kaiverrettu tuffi",
  "block.minecraft.chiseled_tuff_bricks": "Kaiverretut tuffitiilet",
  "block.minecraft.chorus_flower": "Chorus-kukka",
  "block.minecraft.chorus_plant": "Chorus-kasvi",
  "block.minecraft.clay": "Savi",
  "block.minecraft.closed_eyeblossom": "Sulkeutunut silmäkukka",
  "block.minecraft.coal_block": "Hiilikuutio",
  "block.minecraft.coal_ore": "Hiilimalmi",
  "block.minecraft.coarse_dirt": "Karkea multa",
  "block.minecraft.cobbled_deepslate": "Murtunut pohjaliuskekivi",
  "block.minecraft.cobbled_deepslate_slab": "Murtunut pohjaliuskekivilaatta",
  "block.minecraft.cobbled_deepslate_stairs": "Murtuneet pohjaliuskekiviportaat",
  "block.minecraft.cobbled_deepslate_wall": "Murtunut pohjaliuskekivimuuri",
  "block.minecraft.cobblestone": "Mukulakivi",
  "block.minecraft.cobblestone_slab": "Mukulakivilaatta",
  "block.minecraft.cobblestone_stairs": "Mukulakiviportaat",
  "block.minecraft.cobblestone_wall": "Mukulakivimuuri",
  "block.minecraft.cobweb": "Hämähäkinseitti",
  "block.minecraft.cocoa": "Kaakao",
  "block.minecraft.command_block": "Komentokuutio",
  "block.minecraft.comparator": "Redstone-komparaattori",
  "block.minecraft.composter": "Komposti",
  "block.minecraft.conduit": "Kanavoija",
  "block.minecraft.copper_bars": "Kuparikalterit",
  "block.minecraft.copper_block": "Kuparikuutio",
  "block.minecraft.copper_bulb": "Kuparilamppu",
  "block.minecraft.copper_chain": "Kupariketju",
  "block.minecraft.copper_chest": "Kupariarkku",
  "block.minecraft.copper_door": "Kupariovi",
  "block.minecraft.copper_golem_statue": "Kuparigolempatsas",
  "block.minecraft.copper_grate": "Kupariritilä",
  "block.minecraft.copper_lantern": "Kuparilyhty",
  "block.minecraft.copper_ore": "Kuparimalmi",
  "block.minecraft.copper_torch": "Kuparisoihtu",
  "block.minecraft.copper_trapdoor": "Kupariluukku",
  "block.minecraft.copper_wall_torch": "Seinälle asetettu kuparisoihtu",
  "block.minecraft.cornflower": "Ruiskaunokki",
  "block.minecraft.cracked_deepslate_bricks": "Murtuneet pohjaliuskekivitiilet",
  "block.minecraft.cracked_deepslate_tiles": "Murtuneet pohjaliuskekivikaakelit",
  "block.minecraft.cracked_nether_bricks": "Murtuneet Nether-tiilet",
  "block.minecraft.cracked_polished_blackstone_bricks": "Murtuneet kiillotetut mustakivitiilet",
  "block.minecraft.cracked_stone_bricks": "Murtunet kivitiilet",
  "block.minecraft.crafter": "Työstin",
  "block.minecraft.crafting_table": "Työpöytä",
  "block.minecraft.creaking_heart": "Narahteleva sydän",
  "block.minecraft.creeper_head": "Creeperin pää",
  "block.minecraft.creeper_wall_head": "Ripustettu creeperin pää",
  "block.minecraft.crimson_button": "Karmiininappi",
  "block.minecraft.crimson_door": "Karmiiniovi",
  "block.minecraft.crimson_fence": "Karmiiniaita",
  "block.minecraft.crimson_fence_gate": "Karmiiniportti",
  "block.minecraft.crimson_fungus": "Karmiinisieni",
  "block.minecraft.crimson_hanging_sign": "Roikkuva karmiinikyltti",
  "block.minecraft.crimson_hyphae": "Karmiinirihma",
  "block.minecraft.crimson_nylium": "Karmiinisienirihmasto",
  "block.minecraft.crimson_planks": "Karmiinilankut",
  "block.minecraft.crimson_pressure_plate": "Karmiinipainelaatta",
  "block.minecraft.crimson_roots": "Karmiinijuuret",
  "block.minecraft.crimson_shelf": "Karmiinihylly",
  "block.minecraft.crimson_sign": "Karmiinikyltti",
  "block.minecraft.crimson_slab": "Karmiinilaatta",
  "block.minecraft.crimson_stairs": "Karmiiniportaat",
  "block.minecraft.crimson_stem": "Karmiinivarsi",
  "block.minecraft.crimson_trapdoor": "Karmiiniluukku",
  "block.minecraft.crimson_wall_hanging_sign": "Riippuva karmiinikyltti",
  "block.minecraft.crimson_wall_sign": "Ripustettu karmiinikyltti",
  "block.minecraft.crying_obsidian": "Itkevä obsidiaani",
  "block.minecraft.cut_copper": "Leikattu kupari",
  "block.minecraft.cut_copper_slab": "Leikattu kuparilaatta",
  "block.minecraft.cut_copper_stairs": "Leikatut kupariportaat",
  "block.minecraft.cut_red_sandstone": "Leikattu punahiekkakivi",
  "block.minecraft.cut_red_sandstone_slab": "Leikattu punahiekkakivilaatta",
  "block.minecraft.cut_sandstone": "Leikattu hiekkakivi",
  "block.minecraft.cut_sandstone_slab": "Leikattu hiekkakivilaatta",
  "block.minecraft.cyan_banner": "Syaani viiri",
  "block.minecraft.cyan_bed": "Syaani sänky",
  "block.minecraft.cyan_candle": "Syaani kynttilä",
  "block.minecraft.cyan_candle_cake": "Kakku syaanilla kynttilällä",
  "block.minecraft.cyan_carpet": "Syaani matto",
  "block.minecraft.cyan_concrete": "Syaani betoni",
  "block.minecraft.cyan_concrete_powder": "Syaani betonijauhe",
  "block.minecraft.cyan_glazed_terracotta": "Syaani lasitettu terrakotta",
  "block.minecraft.cyan_shulker_box": "Syaani shulker-laatikko",
  "block.minecraft.cyan_stained_glass": "Syaani lasi",
  "block.minecraft.cyan_stained_glass_pane": "Syaani lasipaneeli",
  "block.minecraft.cyan_terracotta": "Syaani terrakotta",
  "block.minecraft.cyan_wool": "Syaani villa",
  "block.minecraft.damaged_anvil": "Vaurioitunut alasin",
  "block.minecraft.dandelion": "Voikukka",
  "block.minecraft.dark_oak_button": "Tumma tamminappi",
  "block.minecraft.dark_oak_door": "Tumma tammiovi",
  "block.minecraft.dark_oak_fence": "Tumma tammiaita",
  "block.minecraft.dark_oak_fence_gate": "Tumma tammiportti",
  "block.minecraft.dark_oak_hanging_sign": "Roikkuva tumma tammikyltti",
  "block.minecraft.dark_oak_leaves": "Tumman tammen lehdet",
  "block.minecraft.dark_oak_log": "Tumma tammihalko",
  "block.minecraft.dark_oak_planks": "Tummat tammilankut",
  "block.minecraft.dark_oak_pressure_plate": "Tumma tammipainelaatta",
  "block.minecraft.dark_oak_sapling": "Tumman tammen taimi",
  "block.minecraft.dark_oak_shelf": "Tumma tammihylly",
  "block.minecraft.dark_oak_sign": "Tumma tammikyltti",
  "block.minecraft.dark_oak_slab": "Tumma tammilaatta",
  "block.minecraft.dark_oak_stairs": "Tummat tammiportaat",
  "block.minecraft.dark_oak_trapdoor": "Tumma tammiluukku",
  "block.minecraft.dark_oak_wall_hanging_sign": "Riippuva tumma tammikyltti",
  "block.minecraft.dark_oak_wall_sign": "Ripustettu tumma tammikyltti",
  "block.minecraft.dark_oak_wood": "Tumma tammipuu",
  "block.minecraft.dark_prismarine": "Tumma prismariini",
  "block.minecraft.dark_prismarine_slab": "Tumma prismariinilaatta",
  "block.minecraft.dark_prismarine_stairs": "Tummat prismariiniportaat",
  "block.minecraft.daylight_detector": "Päivänvalotunnistin",
  "block.minecraft.dead_brain_coral": "Kuollut aivokoralli",
  "block.minecraft.dead_brain_coral_block": "Kuollut aivokorallikuutio",
  "block.minecraft.dead_brain_coral_fan": "Kuollut aivokoralliviuhka",
  "block.minecraft.dead_brain_coral_wall_fan": "Kuollut seinäaivokoralliviuhka",
  "block.minecraft.dead_bubble_coral": "Kuollut kuplakoralli",
  "block.minecraft.dead_bubble_coral_block": "Kuollut kuplakorallikuutio",
  "block.minecraft.dead_bubble_coral_fan": "Kuollut kuplakoralliviuhka",
  "block.minecraft.dead_bubble_coral_wall_fan": "Kuollut seinäkuplakoralliviuhka",
  "block.minecraft.dead_bush": "Kuollut pensas",
  "block.minecraft.dead_fire_coral": "Kuollut tulikoralli",
  "block.minecraft.dead_fire_coral_block": "Kuollut tulikorallikuutio",
  "block.minecraft.dead_fire_coral_fan": "Kuollut tulikoralliviuhka",
  "block.minecraft.dead_fire_coral_wall_fan": "Kuollut seinätulikoralliviuhka",
  "block.minecraft.dead_horn_coral": "Kuollut torvikoralli",
  "block.minecraft.dead_horn_coral_block": "Kuollut torvikorallikuutio",
  "block.minecraft.dead_horn_coral_fan": "Kuollut torvikoralliviuhka",
  "block.minecraft.dead_horn_coral_wall_fan": "Kuollut seinätorvikoralliviuhka",
  "block.minecraft.dead_tube_coral": "Kuollut putkikoralli",
  "block.minecraft.dead_tube_coral_block": "Kuollut putkikorallikuutio",
  "block.minecraft.dead_tube_coral_fan": "Kuollut putkikoralliviuhka",
  "block.minecraft.dead_tube_coral_wall_fan": "Kuollut seinäputkikoralliviuhka",
  "block.minecraft.decorated_pot": "Koristeltu ruukku",
  "block.minecraft.deepslate": "Pohjaliuskekivi",
  "block.minecraft.deepslate_brick_slab": "Pohjaliuskekivitiililaatta",
  "block.minecraft.deepslate_brick_stairs": "Pohjaliuskekivitiiliportaat",
  "block.minecraft.deepslate_brick_wall": "Pohjaliuskekivitiilimuuri",
  "block.minecraft.deepslate_bricks": "Pohjaliuskekivitiilet",
  "block.minecraft.deepslate_coal_ore": "Pohjaliuskehiilimalmi",
  "block.minecraft.deepslate_copper_ore": "Pohjaliuskekuparimalmi",
  "block.minecraft.deepslate_diamond_ore": "Pohjaliusketimanttimalmi",
  "block.minecraft.deepslate_emerald_ore": "Pohjaliuskesmaragdimalmi",
  "block.minecraft.deepslate_gold_ore": "Pohjaliuskekultamalmi",
  "block.minecraft.deepslate_iron_ore": "Pohjaliuskerautamalmi",
  "block.minecraft.deepslate_lapis_ore": "Pohjaliuskelasuriittimalmi",
  "block.minecraft.deepslate_redstone_ore": "Pohjaliuskeredstone-malmi",
  "block.minecraft.deepslate_tile_slab": "Pohjaliuskekivikaakelilaatta",
  "block.minecraft.deepslate_tile_stairs": "Pohjaliuskekivikaakeliportaat",
  "block.minecraft.deepslate_tile_wall": "Pohjaliuskekivikaakelimuuri",
  "block.minecraft.deepslate_tiles": "Pohjaliuskekivikaakelit",
  "block.minecraft.detector_rail": "Tunnistinraide",
  "block.minecraft.diamond_block": "Timanttikuutio",
  "block.minecraft.diamond_ore": "Timanttimalmi",
  "block.minecraft.diorite": "Dioriitti",
  "block.minecraft.diorite_slab": "Dioriittilaatta",
  "block.minecraft.diorite_stairs": "Dioriittiportaat",
  "block.minecraft.diorite_wall": "Dioriittimuuri",
  "block.minecraft.dirt": "Multa",
  "block.minecraft.dirt_path": "Multapolku",
  "block.minecraft.dispenser": "Jakelulaite",
  "block.minecraft.dragon_egg": "Lohikäärmeen muna",
  "block.minecraft.dragon_head": "Lohikäärmeen pää",
  "block.minecraft.dragon_wall_head": "Ripustettu lohikäärmeen pää",
  "block.minecraft.dried_ghast": "Kuivunut ghast",
  "block.minecraft.dried_kelp_block": "Kuivattu rakkoleväkuutio",
  "block.minecraft.dripstone_block": "Tippukivikuutio",
  "block.minecraft.dropper": "Pudottaja",
  "block.minecraft.emerald_block": "Smaragdikuutio",
  "block.minecraft.emerald_ore": "Smaragdimalmi",
  "block.minecraft.enchanting_table": "Lumouspöytä",
  "block.minecraft.end_gateway": "End-portti",
  "block.minecraft.end_portal": "End-portaali",
  "block.minecraft.end_portal_frame": "End-portaalin kehys",
  "block.minecraft.end_rod": "End-sauva",
  "block.minecraft.end_stone": "End-kivi",
  "block.minecraft.end_stone_brick_slab": "End-kivitiililaatta",
  "block.minecraft.end_stone_brick_stairs": "End-kivitiiliportaat",
  "block.minecraft.end_stone_brick_wall": "End-kivitiilimuuri",
  "block.minecraft.end_stone_bricks": "End-kivitiilet",
  "block.minecraft.ender_chest": "Ender-arkku",
  "block.minecraft.exposed_chiseled_copper": "Altistunut kaiverrettu kupari",
  "block.minecraft.exposed_copper": "Altistunut kupari",
  "block.minecraft.exposed_copper_bars": "Altistuneet kuparikalterit",
  "block.minecraft.exposed_copper_bulb": "Altistunut kuparilamppu",
  "block.minecraft.exposed_copper_chain": "Altistunut kupariketju",
  "block.minecraft.exposed_copper_chest": "Altistunut kupariarkku",
  "block.minecraft.exposed_copper_door": "Altistunut kupariovi",
  "block.minecraft.exposed_copper_golem_statue": "Altistunut kuparigolempatsas",
  "block.minecraft.exposed_copper_grate": "Altistunut kupariritilä",
  "block.minecraft.exposed_copper_lantern": "Altistunut kuparilyhty",
  "block.minecraft.exposed_copper_trapdoor": "Altistunut kupariluukku",
  "block.minecraft.exposed_cut_copper": "Altistunut leikattu kupari",
  "block.minecraft.exposed_cut_copper_slab": "Altistunut leikattu kuparilaatta",
  "block.minecraft.exposed_cut_copper_stairs": "Altistuneet leikatut kupariportaat",
  "block.minecraft.exposed_lightning_rod": "Altistunut ukkosenjohdatin",
  "block.minecraft.farmland": "Viljelysmaa",
  "block.minecraft.fern": "Saniainen",
  "block.minecraft.fire": "Tuli",
  "block.minecraft.fire_coral": "Tulikoralli",
  "block.minecraft.fire_coral_block": "Tulikorallikuutio",
  "block.minecraft.fire_coral_fan": "Tulikoralliviuhka",
  "block.minecraft.fire_coral_wall_fan": "Seinätulikoralliviuhka",
  "block.minecraft.firefly_bush": "Tulikärpäspensas",
  "block.minecraft.fletching_table": "Nuolipöytä",
  "block.minecraft.flower_pot": "Kukkaruukku",
  "block.minecraft.flowering_azalea": "Kukkiva atsalea",
  "block.minecraft.flowering_azalea_leaves": "Kukkivan atsalean lehdet",
  "block.minecraft.frogspawn": "Sammakonkutu",
  "block.minecraft.frosted_ice": "Huurteinen jää",
  "block.minecraft.furnace": "Uuni",
  "block.minecraft.gilded_blackstone": "Kullattu mustakivi",
  "block.minecraft.glass": "Lasi",
  "block.minecraft.glass_pane": "Lasipaneeli",
  "block.minecraft.glow_lichen": "Hehkujäkälä",
  "block.minecraft.glowstone": "Hehkukivi",
  "block.minecraft.gold_block": "Kultakuutio",
  "block.minecraft.gold_ore": "Kultamalmi",
  "block.minecraft.golden_dandelion": "Kultainen voikukka",
  "block.minecraft.granite": "Graniitti",
  "block.minecraft.granite_slab": "Graniittilaatta",
  "block.minecraft.granite_stairs": "Graniittiportaat",
  "block.minecraft.granite_wall": "Graniittimuuri",
  "block.minecraft.grass": "Ruoho",
  "block.minecraft.grass_block": "Ruohokuutio",
  "block.minecraft.gravel": "Sora",
  "block.minecraft.gray_banner": "Harmaa viiri",
  "block.minecraft.gray_bed": "Harmaa sänky",
  "block.minecraft.gray_candle": "Harmaa kynttilä",
  "block.minecraft.gray_candle_cake": "Kakku harmaalla kynttilällä",
  "block.minecraft.gray_carpet": "Harmaa matto",
  "block.minecraft.gray_concrete": "Harmaa betoni",
  "block.minecraft.gray_concrete_powder": "Harmaa betonijauhe",
  "block.minecraft.gray_glazed_terracotta": "Harmaa lasitettu terrakotta",
  "block.minecraft.gray_shulker_box": "Harmaa shulker-laatikko",
  "block.minecraft.gray_stained_glass": "Harmaa lasi",
  "block.minecraft.gray_stained_glass_pane": "Harmaa lasipaneeli",
  "block.minecraft.gray_terracotta": "Harmaa terrakotta",
  "block.minecraft.gray_wool": "Harmaa villa",
  "block.minecraft.green_banner": "Vihreä viiri",
  "block.minecraft.green_bed": "Vihreä sänky",
  "block.minecraft.green_candle": "Vihreä kynttilä",
  "block.minecraft.green_candle_cake": "Kakku vihreällä kynttilällä",
  "block.minecraft.green_carpet": "Vihreä matto",
  "block.minecraft.green_concrete": "Vihreä betoni",
  "block.minecraft.green_concrete_powder": "Vihreä betonijauhe",
  "block.minecraft.green_glazed_terracotta": "Vihreä lasitettu terrakotta",
  "block.minecraft.green_shulker_box": "Vihreä shulker-laatikko",
  "block.minecraft.green_stained_glass": "Vihreä lasi",
  "block.minecraft.green_stained_glass_pane": "Vihreä lasipaneeli",
  "block.minecraft.green_terracotta": "Vihreä terrakotta",
  "block.minecraft.green_wool": "Vihreä villa",
  "block.minecraft.grindstone": "Tahko",
  "block.minecraft.hanging_roots": "Roikkuvat juuret",
  "block.minecraft.hay_block": "Heinäpaali",
  "block.minecraft.heavy_core": "Raskas ydin",
  "block.minecraft.heavy_weighted_pressure_plate": "Painava painelaatta",
  "block.minecraft.honey_block": "Hunajakuutio",
  "block.minecraft.honeycomb_block": "Hunajakennokuutio",
  "block.minecraft.hopper": "Suppilo",
  "block.minecraft.horn_coral": "Torvikoralli",
  "block.minecraft.horn_coral_block": "Torvikorallikuutio",
  "block.minecraft.horn_coral_fan": "Torvikoralliviuhka",
  "block.minecraft.horn_coral_wall_fan": "Seinätorvikoralliviuhka",
  "block.minecraft.ice": "Jää",
  "block.minecraft.infested_chiseled_stone_bricks": "Saastuneet kaiverretut kivitiilet",
  "block.minecraft.infested_cobblestone": "Saastunut mukulakivi",
  "block.minecraft.infested_cracked_stone_bricks": "Saastuneet murtuneet kivitiilet",
  "block.minecraft.infested_deepslate": "Saastunut pohjaliuskekivi",
  "block.minecraft.infested_mossy_stone_bricks": "Saastuneet sammaleiset kivitiilet",
  "block.minecraft.infested_stone": "Saastunut kivi",
  "block.minecraft.infested_stone_bricks": "Saastuneet kivitiilet",
  "block.minecraft.iron_bars": "Rautakalterit",
  "block.minecraft.iron_block": "Rautakuutio",
  "block.minecraft.iron_chain": "Rautaketju",
  "block.minecraft.iron_door": "Rautaovi",
  "block.minecraft.iron_ore": "Rautamalmi",
  "block.minecraft.iron_trapdoor": "Rautaluukku",
  "block.minecraft.jack_o_lantern": "Kurpitsalyhty",
  "block.minecraft.jigsaw": "Palapelikuutio",
  "block.minecraft.jukebox": "Levysoitin",
  "block.minecraft.jungle_button": "Viidakkopuunappi",
  "block.minecraft.jungle_door": "Viidakkopuuovi",
  "block.minecraft.jungle_fence": "Viidakkopuuaita",
  "block.minecraft.jungle_fence_gate": "Viidakkopuuportti",
  "block.minecraft.jungle_hanging_sign": "Roikkuva viidakkopuukyltti",
  "block.minecraft.jungle_leaves": "Viidakkopuun lehdet",
  "block.minecraft.jungle_log": "Viidakkopuuhalko",
  "block.minecraft.jungle_planks": "Viidakkopuulankut",
  "block.minecraft.jungle_pressure_plate": "Viidakkopuupainelaatta",
  "block.minecraft.jungle_sapling": "Viidakkopuun taimi",
  "block.minecraft.jungle_shelf": "Viidakkopuuhylly",
  "block.minecraft.jungle_sign": "Viidakkopuukyltti",
  "block.minecraft.jungle_slab": "Viidakkopuulaatta",
  "block.minecraft.jungle_stairs": "Viidakkopuuportaat",
  "block.minecraft.jungle_trapdoor": "Viidakkopuuluukku",
  "block.minecraft.jungle_wall_hanging_sign": "Riippuva viidakkopuukyltti",
  "block.minecraft.jungle_wall_sign": "Ripustettu viidakkopuukyltti",
  "block.minecraft.jungle_wood": "Viidakkopuu",
  "block.minecraft.kelp": "Rakkolevä",
  "block.minecraft.kelp_plant": "Rakkoleväkasvi",
  "block.minecraft.ladder": "Tikas",
  "block.minecraft.lantern": "Lyhty",
  "block.minecraft.lapis_block": "Lasuriittikuutio",
  "block.minecraft.lapis_ore": "Lasuriittimalmi",
  "block.minecraft.large_amethyst_bud": "Suuri ametistinuppu",
  "block.minecraft.large_fern": "Suuri saniainen",
  "block.minecraft.lava": "Laava",
  "block.minecraft.lava_cauldron": "Laavapata",
  "block.minecraft.leaf_litter": "Lehtikarike",
  "block.minecraft.lectern": "Kateederi",
  "block.minecraft.lever": "Vipu",
  "block.minecraft.light": "Valo",
  "block.minecraft.light_blue_banner": "Vaaleansininen viiri",
  "block.minecraft.light_blue_bed": "Vaaleansininen sänky",
  "block.minecraft.light_blue_candle": "Vaaleansininen kynttilä",
  "block.minecraft.light_blue_candle_cake": "Kakku vaaleansinisellä kynttilällä",
  "block.minecraft.light_blue_carpet": "Vaaleansininen matto",
  "block.minecraft.light_blue_concrete": "Vaaleansininen betoni",
  "block.minecraft.light_blue_concrete_powder": "Vaaleansininen betonijauhe",
  "block.minecraft.light_blue_glazed_terracotta": "Vaaleansininen lasitettu terrakotta",
  "block.minecraft.light_blue_shulker_box": "Vaaleansininen shulker-laatikko",
  "block.minecraft.light_blue_stained_glass": "Vaaleansininen lasi",
  "block.minecraft.light_blue_stained_glass_pane": "Vaaleansininen lasipaneeli",
  "block.minecraft.light_blue_terracotta": "Vaaleansininen terrakotta",
  "block.minecraft.light_blue_wool": "Vaaleansininen villa",
  "block.minecraft.light_gray_banner": "Vaaleanharmaa viiri",
  "block.minecraft.light_gray_bed": "Vaaleanharmaa sänky",
  "block.minecraft.light_gray_candle": "Vaaleanharmaa kynttilä",
  "block.minecraft.light_gray_candle_cake": "Kakku vaaleanharmaalla kynttilällä",
  "block.minecraft.light_gray_carpet": "Vaaleanharmaa matto",
  "block.minecraft.light_gray_concrete": "Vaaleanharmaa betoni",
  "block.minecraft.light_gray_concrete_powder": "Vaaleanharmaa betonijauhe",
  "block.minecraft.light_gray_glazed_terracotta": "Vaaleanharmaa lasitettu terrakotta",
  "block.minecraft.light_gray_shulker_box": "Vaaleanharmaa shulker-laatikko",
  "block.minecraft.light_gray_stained_glass": "Vaaleanharmaa lasi",
  "block.minecraft.light_gray_stained_glass_pane": "Vaaleanharmaa lasipaneeli",
  "block.minecraft.light_gray_terracotta": "Vaaleanharmaa terrakotta",
  "block.minecraft.light_gray_wool": "Vaaleanharmaa villa",
  "block.minecraft.light_weighted_pressure_plate": "Kevyt painelaatta",
  "block.minecraft.lightning_rod": "Ukkosenjohdatin",
  "block.minecraft.lilac": "Syreeni",
  "block.minecraft.lily_of_the_valley": "Kielo",
  "block.minecraft.lily_pad": "Lumpeenlehti",
  "block.minecraft.lime_banner": "Limetinvihreä viiri",
  "block.minecraft.lime_bed": "Limetinvihreä sänky",
  "block.minecraft.lime_candle": "Limetinvihreä kynttilä",
  "block.minecraft.lime_candle_cake": "Kakku limetinvihreällä kynttilällä",
  "block.minecraft.lime_carpet": "Limetinvihreä matto",
  "block.minecraft.lime_concrete": "Limetinvihreä betoni",
  "block.minecraft.lime_concrete_powder": "Limetinvihreä betonijauhe",
  "block.minecraft.lime_glazed_terracotta": "Limetinvihreä lasitettu terrakotta",
  "block.minecraft.lime_shulker_box": "Limetinvihreä shulker-laatikko",
  "block.minecraft.lime_stained_glass": "Limetinvihreä lasi",
  "block.minecraft.lime_stained_glass_pane": "Limetinvihreä lasipaneeli",
  "block.minecraft.lime_terracotta": "Limetinvihreä terrakotta",
  "block.minecraft.lime_wool": "Limetinvihreä villa",
  "block.minecraft.lodestone": "Magneettikivi",
  "block.minecraft.loom": "Kangaspuut",
  "block.minecraft.magenta_banner": "Purppura viiri",
  "block.minecraft.magenta_bed": "Purppura sänky",
  "block.minecraft.magenta_candle": "Purppura kynttilä",
  "block.minecraft.magenta_candle_cake": "Kakku purppuralla kynttilällä",
  "block.minecraft.magenta_carpet": "Purppura matto",
  "block.minecraft.magenta_concrete": "Purppura betoni",
  "block.minecraft.magenta_concrete_powder": "Purppura betonijauhe",
  "block.minecraft.magenta_glazed_terracotta": "Purppura lasitettu terrakotta",
  "block.minecraft.magenta_shulker_box": "Purppura shulker-laatikko",
  "block.minecraft.magenta_stained_glass": "Purppura lasi",
  "block.minecraft.magenta_stained_glass_pane": "Purppura lasipaneeli",
  "block.minecraft.magenta_terracotta": "Purppura terrakotta",
  "block.minecraft.magenta_wool": "Purppura villa",
  "block.minecraft.magma_block": "Magmakuutio",
  "block.minecraft.mangrove_button": "Mangrovepuunappi",
  "block.minecraft.mangrove_door": "Mangrovepuuovi",
  "block.minecraft.mangrove_fence": "Mangrovepuuaita",
  "block.minecraft.mangrove_fence_gate": "Mangrovepuuportti",
  "block.minecraft.mangrove_hanging_sign": "Roikkuva mangrovepuukyltti",
  "block.minecraft.mangrove_leaves": "Mangrovepuun lehdet",
  "block.minecraft.mangrove_log": "Mangrovepuuhalko",
  "block.minecraft.mangrove_planks": "Mangrovepuulankut",
  "block.minecraft.mangrove_pressure_plate": "Mangrovepuupainelaatta",
  "block.minecraft.mangrove_propagule": "Mangrovepuun leviäin",
  "block.minecraft.mangrove_roots": "Mangrovepuun juurakko",
  "block.minecraft.mangrove_shelf": "Mangrovepuuhylly",
  "block.minecraft.mangrove_sign": "Mangrovepuukyltti",
  "block.minecraft.mangrove_slab": "Mangrovepuulaatta",
  "block.minecraft.mangrove_stairs": "Mangrovepuuportaat",
  "block.minecraft.mangrove_trapdoor": "Mangrovepuuluukku",
  "block.minecraft.mangrove_wall_hanging_sign": "Riippuva mangrovepuukyltti",
  "block.minecraft.mangrove_wall_sign": "Ripustettu mangrovepuukyltti",
  "block.minecraft.mangrove_wood": "Mangrovepuu",
  "block.minecraft.medium_amethyst_bud": "Keskikokoinen ametistinuppu",
  "block.minecraft.melon": "Meloni",
  "block.minecraft.melon_stem": "Melonin varsi",
  "block.minecraft.moss_block": "Sammalkuutio",
  "block.minecraft.moss_carpet": "Sammalmatto",
  "block.minecraft.mossy_cobblestone": "Sammaleinen mukulakivi",
  "block.minecraft.mossy_cobblestone_slab": "Sammaleinen mukulakivilaatta",
  "block.minecraft.mossy_cobblestone_stairs": "Sammaleiset mukulakiviportaat",
  "block.minecraft.mossy_cobblestone_wall": "Sammaleinen mukulakivimuuri",
  "block.minecraft.mossy_stone_brick_slab": "Sammaleinen kivitiililaatta",
  "block.minecraft.mossy_stone_brick_stairs": "Sammaleiset kivitiiliportaat",
  "block.minecraft.mossy_stone_brick_wall": "Sammaleinen kivitiilimuuri",
  "block.minecraft.mossy_stone_bricks": "Sammaleiset kivitiilet",
  "block.minecraft.moving_piston": "Liikkuva mäntä",
  "block.minecraft.mud": "Muta",
  "block.minecraft.mud_brick_slab": "Mutatiililaatta",
  "block.minecraft.mud_brick_stairs": "Mutatiiliportaat",
  "block.minecraft.mud_brick_wall": "Mutatiilimuuri",
  "block.minecraft.mud_bricks": "Mutatiilet",
  "block.minecraft.muddy_mangrove_roots": "Mutainen mangrovepuun juurakko",
  "block.minecraft.mushroom_stem": "Sienen varsi",
  "block.minecraft.mycelium": "Sienirihmasto",
  "block.minecraft.nether_brick_fence": "Nether-tiiliaita",
  "block.minecraft.nether_brick_slab": "Nether-tiililaatta",
  "block.minecraft.nether_brick_stairs": "Nether-tiiliportaat",
  "block.minecraft.nether_brick_wall": "Nether-tiilimuuri",
  "block.minecraft.nether_bricks": "Nether-tiilet",
  "block.minecraft.nether_gold_ore": "Nether-kultamalmi",
  "block.minecraft.nether_portal": "Nether-portaali",
  "block.minecraft.nether_quartz_ore": "Nether-kvartsimalmi",
  "block.minecraft.nether_sprouts": "Nether-verso",
  "block.minecraft.nether_wart": "Nether-pahka",
  "block.minecraft.nether_wart_block": "Nether-pahkakuutio",
  "block.minecraft.netherite_block": "Netheriittikuutio",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Sointukuutio",
  "block.minecraft.oak_button": "Tamminappi",
  "block.minecraft.oak_door": "Tammiovi",
  "block.minecraft.oak_fence": "Tammiaita",
  "block.minecraft.oak_fence_gate": "Tammiportti",
  "block.minecraft.oak_hanging_sign": "Roikkuva tammikyltti",
  "block.minecraft.oak_leaves": "Tammenlehdet",
  "block.minecraft.oak_log": "Tammihalko",
  "block.minecraft.oak_planks": "Tammilankut",
  "block.minecraft.oak_pressure_plate": "Tammipainelaatta",
  "block.minecraft.oak_sapling": "Tammen taimi",
  "block.minecraft.oak_shelf": "Tammihylly",
  "block.minecraft.oak_sign": "Tammikyltti",
  "block.minecraft.oak_slab": "Tammilaatta",
  "block.minecraft.oak_stairs": "Tammiportaat",
  "block.minecraft.oak_trapdoor": "Tammiluukku",
  "block.minecraft.oak_wall_hanging_sign": "Riippuva tammikyltti",
  "block.minecraft.oak_wall_sign": "Ripustettu tammikyltti",
  "block.minecraft.oak_wood": "Tammipuu",
  "block.minecraft.observer": "Tarkkailija",
  "block.minecraft.obsidian": "Obsidiaani",
  "block.minecraft.ochre_froglight": "Okrankeltainen sammakkovalo",
  "block.minecraft.ominous_banner": "Pahaenteinen viiri",
  "block.minecraft.open_eyeblossom": "Avautunut silmäkukka",
  "block.minecraft.orange_banner": "Oranssi viiri",
  "block.minecraft.orange_bed": "Oranssi sänky",
  "block.minecraft.orange_candle": "Oranssi kynttilä",
  "block.minecraft.orange_candle_cake": "Kakku oranssilla kynttilällä",
  "block.minecraft.orange_carpet": "Oranssi matto",
  "block.minecraft.orange_concrete": "Oranssi betoni",
  "block.minecraft.orange_concrete_powder": "Oranssi betonijauhe",
  "block.minecraft.orange_glazed_terracotta": "Oranssi lasitettu terrakotta",
  "block.minecraft.orange_shulker_box": "Oranssi shulker-laatikko",
  "block.minecraft.orange_stained_glass": "Oranssi lasi",
  "block.minecraft.orange_stained_glass_pane": "Oranssi lasipaneeli",
  "block.minecraft.orange_terracotta": "Oranssi terrakotta",
  "block.minecraft.orange_tulip": "Oranssi tulppaani",
  "block.minecraft.orange_wool": "Oranssi villa",
  "block.minecraft.oxeye_daisy": "Päivänkakkara",
  "block.minecraft.oxidized_chiseled_copper": "Hapettunut kaiverrettu kupari",
  "block.minecraft.oxidized_copper": "Hapettunut kupari",
  "block.minecraft.oxidized_copper_bars": "Hapettuneet kuparikalterit",
  "block.minecraft.oxidized_copper_bulb": "Hapettunut kuparilamppu",
  "block.minecraft.oxidized_copper_chain": "Hapettunut kupariketju",
  "block.minecraft.oxidized_copper_chest": "Hapettunut kupariarkku",
  "block.minecraft.oxidized_copper_door": "Hapettunut kupariovi",
  "block.minecraft.oxidized_copper_golem_statue": "Hapettunut kuparigolempatsas",
  "block.minecraft.oxidized_copper_grate": "Hapettunut kupariritilä",
  "block.minecraft.oxidized_copper_lantern": "Hapettunut kuparilyhty",
  "block.minecraft.oxidized_copper_trapdoor": "Hapettunut kupariluukku",
  "block.minecraft.oxidized_cut_copper": "Hapettunut leikattu kupari",
  "block.minecraft.oxidized_cut_copper_slab": "Hapettunut leikattu kuparilaatta",
  "block.minecraft.oxidized_cut_copper_stairs": "Hapettuneet leikatut kupariportaat",
  "block.minecraft.oxidized_lightning_rod": "Hapettunut ukkosenjohdatin",
  "block.minecraft.packed_ice": "Pakkautunut jää",
  "block.minecraft.packed_mud": "Pakkautunut muta",
  "block.minecraft.pale_hanging_moss": "Roikkuva kalvassammal",
  "block.minecraft.pale_moss_block": "Kalvassammalkuutio",
  "block.minecraft.pale_moss_carpet": "Kalvassammalmatto",
  "block.minecraft.pale_oak_button": "Kalvastamminappi",
  "block.minecraft.pale_oak_door": "Kalvastammiovi",
  "block.minecraft.pale_oak_fence": "Kalvastammiaita",
  "block.minecraft.pale_oak_fence_gate": "Kalvastammiportti",
  "block.minecraft.pale_oak_hanging_sign": "Roikkuva kalvastammikyltti",
  "block.minecraft.pale_oak_leaves": "Kalvastammenlehdet",
  "block.minecraft.pale_oak_log": "Kalvastammihalko",
  "block.minecraft.pale_oak_planks": "Kalvastammilankut",
  "block.minecraft.pale_oak_pressure_plate": "Kalvastammipainelaatta",
  "block.minecraft.pale_oak_sapling": "Kalvastammen taimi",
  "block.minecraft.pale_oak_shelf": "Kalvastammihylly",
  "block.minecraft.pale_oak_sign": "Kalvastammikyltti",
  "block.minecraft.pale_oak_slab": "Kalvastammilaatta",
  "block.minecraft.pale_oak_stairs": "Kalvastammiportaat",
  "block.minecraft.pale_oak_trapdoor": "Kalvastammiluukku",
  "block.minecraft.pale_oak_wall_hanging_sign": "Riippuva kalvastammikyltti",
  "block.minecraft.pale_oak_wall_sign": "Ripustettu kalvastammikyltti",
  "block.minecraft.pale_oak_wood": "Kalvastammipuu",
  "block.minecraft.pearlescent_froglight": "Helmiäisenhohtoinen sammakkovalo",
  "block.minecraft.peony": "Pioni",
  "block.minecraft.petrified_oak_slab": "Kivettynyt tammilaatta",
  "block.minecraft.piglin_head": "Piglinin pää",
  "block.minecraft.piglin_wall_head": "Ripustettu piglinin pää",
  "block.minecraft.pink_banner": "Vaaleanpunainen viiri",
  "block.minecraft.pink_bed": "Vaaleanpunainen sänky",
  "block.minecraft.pink_candle": "Vaaleanpunainen kynttilä",
  "block.minecraft.pink_candle_cake": "Kakku vaaleanpunaisella kynttilällä",
  "block.minecraft.pink_carpet": "Vaaleanpunainen matto",
  "block.minecraft.pink_concrete": "Vaaleanpunainen betoni",
  "block.minecraft.pink_concrete_powder": "Vaaleanpunainen betonijauhe",
  "block.minecraft.pink_glazed_terracotta": "Vaaleanpunainen lasitettu terrakotta",
  "block.minecraft.pink_petals": "Vaaleanpunaiset terälehdet",
  "block.minecraft.pink_shulker_box": "Vaaleanpunainen shulker-laatikko",
  "block.minecraft.pink_stained_glass": "Vaaleanpunainen lasi",
  "block.minecraft.pink_stained_glass_pane": "Vaaleanpunainen lasipaneeli",
  "block.minecraft.pink_terracotta": "Vaaleanpunainen terrakotta",
  "block.minecraft.pink_tulip": "Vaaleanpunainen tulppaani",
  "block.minecraft.pink_wool": "Vaaleanpunainen villa",
  "block.minecraft.piston": "Mäntä",
  "block.minecraft.piston_head": "Männän pää",
  "block.minecraft.pitcher_crop": "Sinikannu",
  "block.minecraft.pitcher_plant": "Sinikannu",
  "block.minecraft.player_head": "Pelaajan pää",
  "block.minecraft.player_head.named": "Pelaajan %s pää",
  "block.minecraft.player_wall_head": "Ripustettu pelaajan pää",
  "block.minecraft.podzol": "Podsoli",
  "block.minecraft.pointed_dripstone": "Terävä tippukivi",
  "block.minecraft.polished_andesite": "Kiillotettu andesiitti",
  "block.minecraft.polished_andesite_slab": "Kiillotettu andesiittilaatta",
  "block.minecraft.polished_andesite_stairs": "Kiillotetut andesiittiportaat",
  "block.minecraft.polished_basalt": "Kiillotettu basaltti",
  "block.minecraft.polished_blackstone": "Kiillotettu mustakivi",
  "block.minecraft.polished_blackstone_brick_slab": "Kiillotettu mustakivitiililaatta",
  "block.minecraft.polished_blackstone_brick_stairs": "Kiillotetut mustakivitiiliportaat",
  "block.minecraft.polished_blackstone_brick_wall": "Kiillotettu mustakivitiilimuuri",
  "block.minecraft.polished_blackstone_bricks": "Kiillotetut mustakivitiilet",
  "block.minecraft.polished_blackstone_button": "Kiillotettu mustakivinappi",
  "block.minecraft.polished_blackstone_pressure_plate": "Kiillotettu mustakivipainelaatta",
  "block.minecraft.polished_blackstone_slab": "Kiillotettu mustakivilaatta",
  "block.minecraft.polished_blackstone_stairs": "Kiillotetut mustakiviportaat",
  "block.minecraft.polished_blackstone_wall": "Kiillotettu mustakivimuuri",
  "block.minecraft.polished_deepslate": "Kiillotettu pohjaliuskekivi",
  "block.minecraft.polished_deepslate_slab": "Kiillotettu pohjaliuskekivilaatta",
  "block.minecraft.polished_deepslate_stairs": "Kiillotetut pohjaliuskekiviportaat",
  "block.minecraft.polished_deepslate_wall": "Kiillotettu pohjaliuskekivimuuri",
  "block.minecraft.polished_diorite": "Kiillotettu dioriitti",
  "block.minecraft.polished_diorite_slab": "Kiillotettu dioriittilaatta",
  "block.minecraft.polished_diorite_stairs": "Kiillotetut dioriittiportaat",
  "block.minecraft.polished_granite": "Kiillotettu graniitti",
  "block.minecraft.polished_granite_slab": "Kiillotettu graniittilaatta",
  "block.minecraft.polished_granite_stairs": "Kiillotetut graniittiportaat",
  "block.minecraft.polished_tuff": "Kiillotettu tuffi",
  "block.minecraft.polished_tuff_slab": "Kiillotettu tuffilaatta",
  "block.minecraft.polished_tuff_stairs": "Kiillotetut tuffiportaat",
  "block.minecraft.polished_tuff_wall": "Kiillotettu tuffimuuri",
  "block.minecraft.poppy": "Unikko",
  "block.minecraft.potatoes": "Peruna",
  "block.minecraft.potted_acacia_sapling": "Istutettu akaasian taimi",
  "block.minecraft.potted_allium": "Istutettu laukka",
  "block.minecraft.potted_azalea_bush": "Istutettu atsalea",
  "block.minecraft.potted_azure_bluet": "Istutettu keijunsilmä",
  "block.minecraft.potted_bamboo": "Istutettu bambu",
  "block.minecraft.potted_birch_sapling": "Istutettu koivun taimi",
  "block.minecraft.potted_blue_orchid": "Istutettu sininen orkidea",
  "block.minecraft.potted_brown_mushroom": "Istutettu ruskea sieni",
  "block.minecraft.potted_cactus": "Istutettu kaktus",
  "block.minecraft.potted_cherry_sapling": "Istutettu kirsikkapuun taimi",
  "block.minecraft.potted_closed_eyeblossom": "Istutettu sulkeutunut silmäkukka",
  "block.minecraft.potted_cornflower": "Istutettu ruiskaunokki",
  "block.minecraft.potted_crimson_fungus": "Istutettu karmiinisieni",
  "block.minecraft.potted_crimson_roots": "Istutetut karmiinijuuret",
  "block.minecraft.potted_dandelion": "Istutettu voikukka",
  "block.minecraft.potted_dark_oak_sapling": "Istutettu tumman tammen taimi",
  "block.minecraft.potted_dead_bush": "Istutettu kuollut pensas",
  "block.minecraft.potted_fern": "Istutettu saniainen",
  "block.minecraft.potted_flowering_azalea_bush": "Istutettu kukkiva atsalea",
  "block.minecraft.potted_golden_dandelion": "Istutettu kultainen voikukka",
  "block.minecraft.potted_jungle_sapling": "Istutettu viidakkopuun taimi",
  "block.minecraft.potted_lily_of_the_valley": "Istutettu kielo",
  "block.minecraft.potted_mangrove_propagule": "Istutettu mangrovepuun leviäin",
  "block.minecraft.potted_oak_sapling": "Istutettu tammen taimi",
  "block.minecraft.potted_open_eyeblossom": "Istutettu avautunut silmäkukka",
  "block.minecraft.potted_orange_tulip": "Istutettu oranssi tulppaani",
  "block.minecraft.potted_oxeye_daisy": "Istutettu päivänkakkara",
  "block.minecraft.potted_pale_oak_sapling": "Istutettu kalvastammen taimi",
  "block.minecraft.potted_pink_tulip": "Istutettu vaaleanpunainen tulppaani",
  "block.minecraft.potted_poppy": "Istutettu unikko",
  "block.minecraft.potted_red_mushroom": "Istutettu kärpässieni",
  "block.minecraft.potted_red_tulip": "Istutettu punainen tulppaani",
  "block.minecraft.potted_spruce_sapling": "Istutettu kuusen taimi",
  "block.minecraft.potted_torchflower": "Istutettu soihtulilja",
  "block.minecraft.potted_warped_fungus": "Istutettu kummasieni",
  "block.minecraft.potted_warped_roots": "Istutetut kummajuuret",
  "block.minecraft.potted_white_tulip": "Istutettu valkoinen tulppaani",
  "block.minecraft.potted_wither_rose": "Istutettu wither-ruusu",
  "block.minecraft.powder_snow": "Puuterilumi",
  "block.minecraft.powder_snow_cauldron": "Puuterilumipata",
  "block.minecraft.powered_rail": "Kiihdytinraide",
  "block.minecraft.prismarine": "Prismariini",
  "block.minecraft.prismarine_brick_slab": "Prismariinitiililaatta",
  "block.minecraft.prismarine_brick_stairs": "Prismariinitiiliportaat",
  "block.minecraft.prismarine_bricks": "Prismariinitiilet",
  "block.minecraft.prismarine_slab": "Prismariinilaatta",
  "block.minecraft.prismarine_stairs": "Prismariiniportaat",
  "block.minecraft.prismarine_wall": "Prismariinimuuri",
  "block.minecraft.pumpkin": "Kurpitsa",
  "block.minecraft.pumpkin_stem": "Kurpitsan varsi",
  "block.minecraft.purple_banner": "Violetti viiri",
  "block.minecraft.purple_bed": "Violetti sänky",
  "block.minecraft.purple_candle": "Violetti kynttilä",
  "block.minecraft.purple_candle_cake": "Kakku violetilla kynttilällä",
  "block.minecraft.purple_carpet": "Violetti matto",
  "block.minecraft.purple_concrete": "Violetti betoni",
  "block.minecraft.purple_concrete_powder": "Violetti betonijauhe",
  "block.minecraft.purple_glazed_terracotta": "Violetti lasitettu terrakotta",
  "block.minecraft.purple_shulker_box": "Violetti shulker-laatikko",
  "block.minecraft.purple_stained_glass": "Violetti lasi",
  "block.minecraft.purple_stained_glass_pane": "Violetti lasipaneeli",
  "block.minecraft.purple_terracotta": "Violetti terrakotta",
  "block.minecraft.purple_wool": "Violetti villa",
  "block.minecraft.purpur_block": "Purpur-kuutio",
  "block.minecraft.purpur_pillar": "Purpur-pilari",
  "block.minecraft.purpur_slab": "Purpur-laatta",
  "block.minecraft.purpur_stairs": "Purpur-portaat",
  "block.minecraft.quartz_block": "Kvartsikuutio",
  "block.minecraft.quartz_bricks": "Kvartsitiilet",
  "block.minecraft.quartz_pillar": "Kvartsipilari",
  "block.minecraft.quartz_slab": "Kvartsilaatta",
  "block.minecraft.quartz_stairs": "Kvartsiportaat",
  "block.minecraft.rail": "Raide",
  "block.minecraft.raw_copper_block": "Raaka kuparikuutio",
  "block.minecraft.raw_gold_block": "Raaka kultakuutio",
  "block.minecraft.raw_iron_block": "Raaka rautakuutio",
  "block.minecraft.red_banner": "Punainen viiri",
  "block.minecraft.red_bed": "Punainen sänky",
  "block.minecraft.red_candle": "Punainen kynttilä",
  "block.minecraft.red_candle_cake": "Kakku punaisella kynttilällä",
  "block.minecraft.red_carpet": "Punainen matto",
  "block.minecraft.red_concrete": "Punainen betoni",
  "block.minecraft.red_concrete_powder": "Punainen betonijauhe",
  "block.minecraft.red_glazed_terracotta": "Punainen lasitettu terrakotta",
  "block.minecraft.red_mushroom": "Kärpässieni",
  "block.minecraft.red_mushroom_block": "Kärpässienikuutio",
  "block.minecraft.red_nether_brick_slab": "Punainen Nether-tiililaatta",
  "block.minecraft.red_nether_brick_stairs": "Punaiset Nether-tiiliportaat",
  "block.minecraft.red_nether_brick_wall": "Punainen Nether-tiilimuuri",
  "block.minecraft.red_nether_bricks": "Punaiset Nether-tiilet",
  "block.minecraft.red_sand": "Punahiekka",
  "block.minecraft.red_sandstone": "Punahiekkakivi",
  "block.minecraft.red_sandstone_slab": "Punahiekkakivilaatta",
  "block.minecraft.red_sandstone_stairs": "Punahiekkakiviportaat",
  "block.minecraft.red_sandstone_wall": "Punahiekkakivimuuri",
  "block.minecraft.red_shulker_box": "Punainen shulker-laatikko",
  "block.minecraft.red_stained_glass": "Punainen lasi",
  "block.minecraft.red_stained_glass_pane": "Punainen lasipaneeli",
  "block.minecraft.red_terracotta": "Punainen terrakotta",
  "block.minecraft.red_tulip": "Punainen tulppaani",
  "block.minecraft.red_wool": "Punainen villa",
  "block.minecraft.redstone_block": "Redstone-kuutio",
  "block.minecraft.redstone_lamp": "Redstone-lamppu",
  "block.minecraft.redstone_ore": "Redstone-malmi",
  "block.minecraft.redstone_torch": "Redstone-soihtu",
  "block.minecraft.redstone_wall_torch": "Seinälle asetettu redstone-soihtu",
  "block.minecraft.redstone_wire": "Redstone-johdin",
  "block.minecraft.reinforced_deepslate": "Vahvistettu pohjaliuskekivi",
  "block.minecraft.repeater": "Redstone-toistin",
  "block.minecraft.repeating_command_block": "Toistava komentokuutio",
  "block.minecraft.resin_block": "Pihkakuutio",
  "block.minecraft.resin_brick_slab": "Pihkatiililaatta",
  "block.minecraft.resin_brick_stairs": "Pihkatiiliportaat",
  "block.minecraft.resin_brick_wall": "Pihkatiilimuuri",
  "block.minecraft.resin_bricks": "Pihkatiilet",
  "block.minecraft.resin_clump": "Pihkakimpale",
  "block.minecraft.respawn_anchor": "Uudelleensyntymisankkuri",
  "block.minecraft.rooted_dirt": "Juurtunut multa",
  "block.minecraft.rose_bush": "Ruusupensas",
  "block.minecraft.sand": "Hiekka",
  "block.minecraft.sandstone": "Hiekkakivi",
  "block.minecraft.sandstone_slab": "Hiekkakivilaatta",
  "block.minecraft.sandstone_stairs": "Hiekkakiviportaat",
  "block.minecraft.sandstone_wall": "Hiekkakivimuuri",
  "block.minecraft.scaffolding": "Rakennusteline",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-herätin",
  "block.minecraft.sculk_sensor": "Sculk-sensori",
  "block.minecraft.sculk_shrieker": "Sculk-kirkuja",
  "block.minecraft.sculk_vein": "Sculk-suoni",
  "block.minecraft.sea_lantern": "Merilyhty",
  "block.minecraft.sea_pickle": "Tulitela",
  "block.minecraft.seagrass": "Meriruoho",
  "block.minecraft.set_spawn": "Uudelleensyntymispiste asetettu",
  "block.minecraft.short_dry_grass": "Lyhyt kuiva ruoho",
  "block.minecraft.short_grass": "Lyhyt ruoho",
  "block.minecraft.shroomlight": "Sienivalo",
  "block.minecraft.shulker_box": "Shulker-laatikko",
  "block.minecraft.skeleton_skull": "Luurangon kallo",
  "block.minecraft.skeleton_wall_skull": "Ripustettu luurangon kallo",
  "block.minecraft.slime_block": "Limakuutio",
  "block.minecraft.small_amethyst_bud": "Pieni ametistinuppu",
  "block.minecraft.small_dripleaf": "Pieni tippulehti",
  "block.minecraft.smithing_table": "Takomispöytä",
  "block.minecraft.smoker": "Savustin",
  "block.minecraft.smooth_basalt": "Sileä basaltti",
  "block.minecraft.smooth_quartz": "Sileä kvartsikuutio",
  "block.minecraft.smooth_quartz_slab": "Sileä kvartsilaatta",
  "block.minecraft.smooth_quartz_stairs": "Sileät kvartsiportaat",
  "block.minecraft.smooth_red_sandstone": "Sileä punahiekkakivi",
  "block.minecraft.smooth_red_sandstone_slab": "Sileä punahiekkakivilaatta",
  "block.minecraft.smooth_red_sandstone_stairs": "Sileät punahiekkakiviportaat",
  "block.minecraft.smooth_sandstone": "Sileä hiekkakivi",
  "block.minecraft.smooth_sandstone_slab": "Sileä hiekkakivilaatta",
  "block.minecraft.smooth_sandstone_stairs": "Sileät hiekkakiviportaat",
  "block.minecraft.smooth_stone": "Sileä kivi",
  "block.minecraft.smooth_stone_slab": "Sileä kivilaatta",
  "block.minecraft.sniffer_egg": "Nuuhkun muna",
  "block.minecraft.snow": "Lumi",
  "block.minecraft.snow_block": "Lumikuutio",
  "block.minecraft.soul_campfire": "Sielunuotio",
  "block.minecraft.soul_fire": "Sielutuli",
  "block.minecraft.soul_lantern": "Sielulyhty",
  "block.minecraft.soul_sand": "Sieluhiekka",
  "block.minecraft.soul_soil": "Sielumulta",
  "block.minecraft.soul_torch": "Sielusoihtu",
  "block.minecraft.soul_wall_torch": "Seinälle asetettu sielusoihtu",
  "block.minecraft.spawn.not_valid": "Sinulla ei ole kotisänkyä eikä ladattua uudelleensyntymisankkuria, tai niiden edessä oli este",
  "block.minecraft.spawner": "Luojakuutio",
  "block.minecraft.spawner.desc1": "Käytä luomismunaa:",
  "block.minecraft.spawner.desc2": "Asettaa olennon tyypin",
  "block.minecraft.sponge": "Pesusieni",
  "block.minecraft.spore_blossom": "Itiökukka",
  "block.minecraft.spruce_button": "Kuusinappi",
  "block.minecraft.spruce_door": "Kuusiovi",
  "block.minecraft.spruce_fence": "Kuusiaita",
  "block.minecraft.spruce_fence_gate": "Kuusiportti",
  "block.minecraft.spruce_hanging_sign": "Roikkuva kuusikyltti",
  "block.minecraft.spruce_leaves": "Kuusenhavut",
  "block.minecraft.spruce_log": "Kuusihalko",
  "block.minecraft.spruce_planks": "Kuusilankut",
  "block.minecraft.spruce_pressure_plate": "Kuusipainelaatta",
  "block.minecraft.spruce_sapling": "Kuusen taimi",
  "block.minecraft.spruce_shelf": "Kuusihylly",
  "block.minecraft.spruce_sign": "Kuusikyltti",
  "block.minecraft.spruce_slab": "Kuusilaatta",
  "block.minecraft.spruce_stairs": "Kuusiportaat",
  "block.minecraft.spruce_trapdoor": "Kuusiluukku",
  "block.minecraft.spruce_wall_hanging_sign": "Riippuva kuusikyltti",
  "block.minecraft.spruce_wall_sign": "Ripustettu kuusikyltti",
  "block.minecraft.spruce_wood": "Kuusipuu",
  "block.minecraft.sticky_piston": "Tarttumamäntä",
  "block.minecraft.stone": "Kivi",
  "block.minecraft.stone_brick_slab": "Kivitiililaatta",
  "block.minecraft.stone_brick_stairs": "Kivitiiliportaat",
  "block.minecraft.stone_brick_wall": "Kivitiilimuuri",
  "block.minecraft.stone_bricks": "Kivitiilet",
  "block.minecraft.stone_button": "Kivinappi",
  "block.minecraft.stone_pressure_plate": "Kivipainelaatta",
  "block.minecraft.stone_slab": "Kivilaatta",
  "block.minecraft.stone_stairs": "Kiviportaat",
  "block.minecraft.stonecutter": "Kivileikkuri",
  "block.minecraft.stripped_acacia_log": "Kuorittu akaasiahalko",
  "block.minecraft.stripped_acacia_wood": "Kuorittu akaasia",
  "block.minecraft.stripped_bamboo_block": "Kuorittu bambukuutio",
  "block.minecraft.stripped_birch_log": "Kuorittu koivuhalko",
  "block.minecraft.stripped_birch_wood": "Kuorittu koivu",
  "block.minecraft.stripped_cherry_log": "Kuorittu kirsikkapuuhalko",
  "block.minecraft.stripped_cherry_wood": "Kuorittu kirsikkapuu",
  "block.minecraft.stripped_crimson_hyphae": "Kuorittu karmiinirihma",
  "block.minecraft.stripped_crimson_stem": "Kuorittu karmiinivarsi",
  "block.minecraft.stripped_dark_oak_log": "Kuorittu tumma tammihalko",
  "block.minecraft.stripped_dark_oak_wood": "Kuorittu tumma tammi",
  "block.minecraft.stripped_jungle_log": "Kuorittu viidakkopuuhalko",
  "block.minecraft.stripped_jungle_wood": "Kuorittu viidakkopuu",
  "block.minecraft.stripped_mangrove_log": "Kuorittu mangrovepuuhalko",
  "block.minecraft.stripped_mangrove_wood": "Kuorittu mangrovepuu",
  "block.minecraft.stripped_oak_log": "Kuorittu tammihalko",
  "block.minecraft.stripped_oak_wood": "Kuorittu tammi",
  "block.minecraft.stripped_pale_oak_log": "Kuorittu kalvastammihalko",
  "block.minecraft.stripped_pale_oak_wood": "Kuorittu kalvastammi",
  "block.minecraft.stripped_spruce_log": "Kuorittu kuusihalko",
  "block.minecraft.stripped_spruce_wood": "Kuorittu kuusi",
  "block.minecraft.stripped_warped_hyphae": "Kuorittu kummarihma",
  "block.minecraft.stripped_warped_stem": "Kuorittu kummavarsi",
  "block.minecraft.structure_block": "Rakennelmakuutio",
  "block.minecraft.structure_void": "Rakennelmatyhjiö",
  "block.minecraft.sugar_cane": "Sokeriruoko",
  "block.minecraft.sunflower": "Auringonkukka",
  "block.minecraft.suspicious_gravel": "Epäilyttävä sora",
  "block.minecraft.suspicious_sand": "Epäilyttävä hiekka",
  "block.minecraft.sweet_berry_bush": "Makea marjapensas",
  "block.minecraft.tall_dry_grass": "Pitkä kuiva ruoho",
  "block.minecraft.tall_grass": "Pitkä ruoho",
  "block.minecraft.tall_seagrass": "Pitkä meriruoho",
  "block.minecraft.target": "Maalitaulu",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Testikuutio",
  "block.minecraft.test_instance_block": "Testitapauskuutio",
  "block.minecraft.tinted_glass": "Tummennettu lasi",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT:n räjähdykset ovat poissa käytöstä",
  "block.minecraft.torch": "Soihtu",
  "block.minecraft.torchflower": "Soihtulilja",
  "block.minecraft.torchflower_crop": "Soihtulilja",
  "block.minecraft.trapped_chest": "Ansoitettu arkku",
  "block.minecraft.trial_spawner": "Koetuksen luojakuutio",
  "block.minecraft.tripwire": "Ansalanka",
  "block.minecraft.tripwire_hook": "Ansalankakoukku",
  "block.minecraft.tube_coral": "Putkikoralli",
  "block.minecraft.tube_coral_block": "Putkikorallikuutio",
  "block.minecraft.tube_coral_fan": "Putkikoralliviuhka",
  "block.minecraft.tube_coral_wall_fan": "Seinäputkikoralliviuhka",
  "block.minecraft.tuff": "Tuffi",
  "block.minecraft.tuff_brick_slab": "Tuffitiililaatta",
  "block.minecraft.tuff_brick_stairs": "Tuffitiiliportaat",
  "block.minecraft.tuff_brick_wall": "Tuffitiilimuuri",
  "block.minecraft.tuff_bricks": "Tuffitiilet",
  "block.minecraft.tuff_slab": "Tuffilaatta",
  "block.minecraft.tuff_stairs": "Tuffiportaat",
  "block.minecraft.tuff_wall": "Tuffimuuri",
  "block.minecraft.turtle_egg": "Kilpikonnan muna",
  "block.minecraft.twisting_vines": "Kieroköynnös",
  "block.minecraft.twisting_vines_plant": "Kieroköynnöskasvi",
  "block.minecraft.vault": "Holvi",
  "block.minecraft.verdant_froglight": "Vihertävä sammakkovalo",
  "block.minecraft.vine": "Köynnös",
  "block.minecraft.void_air": "Tyhjiöilma",
  "block.minecraft.wall_torch": "Seinälle asetettu soihtu",
  "block.minecraft.warped_button": "Kummanappi",
  "block.minecraft.warped_door": "Kummaovi",
  "block.minecraft.warped_fence": "Kumma-aita",
  "block.minecraft.warped_fence_gate": "Kummaportti",
  "block.minecraft.warped_fungus": "Kummasieni",
  "block.minecraft.warped_hanging_sign": "Roikkuva kummakyltti",
  "block.minecraft.warped_hyphae": "Kummarihma",
  "block.minecraft.warped_nylium": "Kummasienirihmasto",
  "block.minecraft.warped_planks": "Kummalankut",
  "block.minecraft.warped_pressure_plate": "Kummapainelaatta",
  "block.minecraft.warped_roots": "Kummajuuret",
  "block.minecraft.warped_shelf": "Kummahylly",
  "block.minecraft.warped_sign": "Kummakyltti",
  "block.minecraft.warped_slab": "Kummalaatta",
  "block.minecraft.warped_stairs": "Kummaportaat",
  "block.minecraft.warped_stem": "Kummavarsi",
  "block.minecraft.warped_trapdoor": "Kummaluukku",
  "block.minecraft.warped_wall_hanging_sign": "Riippuva kummakyltti",
  "block.minecraft.warped_wall_sign": "Ripustettu kummakyltti",
  "block.minecraft.warped_wart_block": "Kummapahkakuutio",
  "block.minecraft.water": "Vesi",
  "block.minecraft.water_cauldron": "Vesipata",
  "block.minecraft.waxed_chiseled_copper": "Vahattu kaiverrettu kupari",
  "block.minecraft.waxed_copper_bars": "Vahatut kuparikalterit",
  "block.minecraft.waxed_copper_block": "Vahattu kuparikuutio",
  "block.minecraft.waxed_copper_bulb": "Vahattu kuparilamppu",
  "block.minecraft.waxed_copper_chain": "Vahattu kupariketju",
  "block.minecraft.waxed_copper_chest": "Vahattu kupariarkku",
  "block.minecraft.waxed_copper_door": "Vahattu kupariovi",
  "block.minecraft.waxed_copper_golem_statue": "Vahattu kuparigolempatsas",
  "block.minecraft.waxed_copper_grate": "Vahattu kupariritilä",
  "block.minecraft.waxed_copper_lantern": "Vahattu kuparilyhty",
  "block.minecraft.waxed_copper_trapdoor": "Vahattu kupariluukku",
  "block.minecraft.waxed_cut_copper": "Vahattu leikattu kupari",
  "block.minecraft.waxed_cut_copper_slab": "Vahattu leikattu kuparilaatta",
  "block.minecraft.waxed_cut_copper_stairs": "Vahatut leikatut kupariportaat",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vahattu altistunut kaiverrettu kupari",
  "block.minecraft.waxed_exposed_copper": "Vahattu altistunut kupari",
  "block.minecraft.waxed_exposed_copper_bars": "Vahatut altistuneet kuparikalterit",
  "block.minecraft.waxed_exposed_copper_bulb": "Vahattu altistunut kuparilamppu",
  "block.minecraft.waxed_exposed_copper_chain": "Vahattu altistunut kupariketju",
  "block.minecraft.waxed_exposed_copper_chest": "Vahattu altistunut kupariarkku",
  "block.minecraft.waxed_exposed_copper_door": "Vahattu altistunut kupariovi",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vahattu altistunut kuparigolempatsas",
  "block.minecraft.waxed_exposed_copper_grate": "Vahattu altistunut kupariritilä",
  "block.minecraft.waxed_exposed_copper_lantern": "Vahattu altistunut kuparilyhty",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vahattu altistunut kupariluukku",
  "block.minecraft.waxed_exposed_cut_copper": "Vahattu altistunut leikattu kupari",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vahattu altistunut leikattu kuparilaatta",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vahatut altistuneet leikatut kupariportaat",
  "block.minecraft.waxed_exposed_lightning_rod": "Vahattu altistunut ukkosenjohdatin",
  "block.minecraft.waxed_lightning_rod": "Vahattu ukkosenjohdatin",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vahattu hapettunut kaiverrettu kupari",
  "block.minecraft.waxed_oxidized_copper": "Vahattu hapettunut kupari",
  "block.minecraft.waxed_oxidized_copper_bars": "Vahatut hapettuneet kuparikalterit",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vahattu hapettunut kuparilamppu",
  "block.minecraft.waxed_oxidized_copper_chain": "Vahattu hapettunut kupariketju",
  "block.minecraft.waxed_oxidized_copper_chest": "Vahattu hapettunut kupariarkku",
  "block.minecraft.waxed_oxidized_copper_door": "Vahattu hapettunut kupariovi",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vahattu hapettunut kuparigolempatsas",
  "block.minecraft.waxed_oxidized_copper_grate": "Vahattu hapettunut kupariritilä",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vahattu hapettunut kuparilyhty",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vahattu hapettunut kupariluukku",
  "block.minecraft.waxed_oxidized_cut_copper": "Vahattu hapettunut leikattu kupari",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vahattu hapettunut leikattu kuparilaatta",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vahatut hapettuneet leikatut kupariportaat",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vahattu hapettunut ukkosenjohdatin",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vahattu rapautunut kaiverrettu kupari",
  "block.minecraft.waxed_weathered_copper": "Vahattu rapautunut kupari",
  "block.minecraft.waxed_weathered_copper_bars": "Vahatut rapautuneet kuparikalterit",
  "block.minecraft.waxed_weathered_copper_bulb": "Vahattu rapautunut kuparilamppu",
  "block.minecraft.waxed_weathered_copper_chain": "Vahattu rapautunut kupariketju",
  "block.minecraft.waxed_weathered_copper_chest": "Vahattu rapautunut kupariarkku",
  "block.minecraft.waxed_weathered_copper_door": "Vahattu rapautunut kupariovi",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vahattu rapautunut kuparigolempatsas",
  "block.minecraft.waxed_weathered_copper_grate": "Vahattu rapautunut kupariritilä",
  "block.minecraft.waxed_weathered_copper_lantern": "Vahattu rapautunut kuparilyhty",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vahattu rapautunut kupariluukku",
  "block.minecraft.waxed_weathered_cut_copper": "Vahattu rapautunut leikattu kupari",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vahattu rapautunut leikattu kuparilaatta",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vahatut rapautuneet leikatut kupariportaat",
  "block.minecraft.waxed_weathered_lightning_rod": "Vahattu rapautunut ukkosenjohdatin",
  "block.minecraft.weathered_chiseled_copper": "Rapautunut kaiverrettu kupari",
  "block.minecraft.weathered_copper": "Rapautunut kupari",
  "block.minecraft.weathered_copper_bars": "Rapautuneet kuparikalterit",
  "block.minecraft.weathered_copper_bulb": "Rapautunut kuparilamppu",
  "block.minecraft.weathered_copper_chain": "Rapautunut kupariketju",
  "block.minecraft.weathered_copper_chest": "Rapautunut kupariarkku",
  "block.minecraft.weathered_copper_door": "Rapautunut kupariovi",
  "block.minecraft.weathered_copper_golem_statue": "Rapautunut kuparigolempatsas",
  "block.minecraft.weathered_copper_grate": "Rapautunut kupariritilä",
  "block.minecraft.weathered_copper_lantern": "Rapautunut kuparilyhty",
  "block.minecraft.weathered_copper_trapdoor": "Rapautunut kupariluukku",
  "block.minecraft.weathered_cut_copper": "Rapautunut leikattu kupari",
  "block.minecraft.weathered_cut_copper_slab": "Rapautunut leikattu kuparilaatta",
  "block.minecraft.weathered_cut_copper_stairs": "Rapautuneet leikatut kupariportaat",
  "block.minecraft.weathered_lightning_rod": "Rapautunut ukkosenjohdatin",
  "block.minecraft.weeping_vines": "Itkuköynnös",
  "block.minecraft.weeping_vines_plant": "Itkuköynnöskasvi",
  "block.minecraft.wet_sponge": "Märkä pesusieni",
  "block.minecraft.wheat": "Vehnä",
  "block.minecraft.white_banner": "Valkoinen viiri",
  "block.minecraft.white_bed": "Valkoinen sänky",
  "block.minecraft.white_candle": "Valkoinen kynttilä",
  "block.minecraft.white_candle_cake": "Kakku valkoisella kynttilällä",
  "block.minecraft.white_carpet": "Valkoinen matto",
  "block.minecraft.white_concrete": "Valkoinen betoni",
  "block.minecraft.white_concrete_powder": "Valkoinen betonijauhe",
  "block.minecraft.white_glazed_terracotta": "Valkoinen lasitettu terrakotta",
  "block.minecraft.white_shulker_box": "Valkoinen shulker-laatikko",
  "block.minecraft.white_stained_glass": "Valkoinen lasi",
  "block.minecraft.white_stained_glass_pane": "Valkoinen lasipaneeli",
  "block.minecraft.white_terracotta": "Valkoinen terrakotta",
  "block.minecraft.white_tulip": "Valkoinen tulppaani",
  "block.minecraft.white_wool": "Valkoinen villa",
  "block.minecraft.wildflowers": "Luonnonkukat",
  "block.minecraft.wither_rose": "Wither-ruusu",
  "block.minecraft.wither_skeleton_skull": "Wither-luurangon kallo",
  "block.minecraft.wither_skeleton_wall_skull": "Ripustettu wither-luurangon kallo",
  "block.minecraft.yellow_banner": "Keltainen viiri",
  "block.minecraft.yellow_bed": "Keltainen sänky",
  "block.minecraft.yellow_candle": "Keltainen kynttilä",
  "block.minecraft.yellow_candle_cake": "Kakku keltaisella kynttilällä",
  "block.minecraft.yellow_carpet": "Keltainen matto",
  "block.minecraft.yellow_concrete": "Keltainen betoni",
  "block.minecraft.yellow_concrete_powder": "Keltainen betonijauhe",
  "block.minecraft.yellow_glazed_terracotta": "Keltainen lasitettu terrakotta",
  "block.minecraft.yellow_shulker_box": "Keltainen shulker-laatikko",
  "block.minecraft.yellow_stained_glass": "Keltainen lasi",
  "block.minecraft.yellow_stained_glass_pane": "Keltainen lasipaneeli",
  "block.minecraft.yellow_terracotta": "Keltainen terrakotta",
  "block.minecraft.yellow_wool": "Keltainen villa",
  "block.minecraft.zombie_head": "Zombin pää",
  "block.minecraft.zombie_wall_head": "Ripustettu zombin pää",
  "item.minecraft.acacia_boat": "Akaasiavene",
  "item.minecraft.acacia_chest_boat": "Akaasiavene arkulla",
  "item.minecraft.allay_spawn_egg": "Luo apuri",
  "item.minecraft.amethyst_shard": "Ametistisirpale",
  "item.minecraft.angler_pottery_shard": "Kalastajan ruukunsirpale",
  "item.minecraft.angler_pottery_sherd": "Kalastajan ruukunsirpale",
  "item.minecraft.apple": "Omena",
  "item.minecraft.archer_pottery_shard": "Jousiampujan ruukunsirpale",
  "item.minecraft.archer_pottery_sherd": "Jousiampujan ruukunsirpale",
  "item.minecraft.armadillo_scute": "Vyötiäisen suomu",
  "item.minecraft.armadillo_spawn_egg": "Luo vyötiäinen",
  "item.minecraft.armor_stand": "Haarniskateline",
  "item.minecraft.arms_up_pottery_shard": "Soturin ruukunsirpale",
  "item.minecraft.arms_up_pottery_sherd": "Soturin ruukunsirpale",
  "item.minecraft.arrow": "Nuoli",
  "item.minecraft.axolotl_bucket": "Aksolotli ämpärissä",
  "item.minecraft.axolotl_spawn_egg": "Luo aksolotli",
  "item.minecraft.baked_potato": "Paistettu peruna",
  "item.minecraft.bamboo_chest_raft": "Bambulautta arkulla",
  "item.minecraft.bamboo_raft": "Bambulautta",
  "item.minecraft.bat_spawn_egg": "Luo lepakko",
  "item.minecraft.bee_spawn_egg": "Luo mehiläinen",
  "item.minecraft.beef": "Raaka pihvi",
  "item.minecraft.beetroot": "Punajuuri",
  "item.minecraft.beetroot_seeds": "Punajuuren siemenet",
  "item.minecraft.beetroot_soup": "Punajuurikeitto",
  "item.minecraft.birch_boat": "Koivuvene",
  "item.minecraft.birch_chest_boat": "Koivuvene arkulla",
  "item.minecraft.black_bundle": "Musta pussi",
  "item.minecraft.black_dye": "Musta väriaine",
  "item.minecraft.black_harness": "Mustat valjaat",
  "item.minecraft.blade_pottery_shard": "Miekan ruukunsirpale",
  "item.minecraft.blade_pottery_sherd": "Miekan ruukunsirpale",
  "item.minecraft.blaze_powder": "Roihujauhe",
  "item.minecraft.blaze_rod": "Roihusauva",
  "item.minecraft.blaze_spawn_egg": "Luo roihu",
  "item.minecraft.blue_bundle": "Sininen pussi",
  "item.minecraft.blue_dye": "Sininen väriaine",
  "item.minecraft.blue_egg": "Sininen muna",
  "item.minecraft.blue_harness": "Siniset valjaat",
  "item.minecraft.bogged_spawn_egg": "Luo rämeinen",
  "item.minecraft.bolt_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Pulttien haarniskakoristeet",
  "item.minecraft.bone": "Luu",
  "item.minecraft.bone_meal": "Luujauho",
  "item.minecraft.book": "Kirja",
  "item.minecraft.bordure_indented_banner_pattern": "Hammaskororeunainen viirikuvio",
  "item.minecraft.bow": "Jousi",
  "item.minecraft.bowl": "Kulho",
  "item.minecraft.bread": "Leipä",
  "item.minecraft.breeze_rod": "Viimasauva",
  "item.minecraft.breeze_spawn_egg": "Luo viima",
  "item.minecraft.brewer_pottery_shard": "Juomanvalmistajan ruukunsirpale",
  "item.minecraft.brewer_pottery_sherd": "Juomanvalmistajan ruukunsirpale",
  "item.minecraft.brewing_stand": "Hautumateline",
  "item.minecraft.brick": "Tiili",
  "item.minecraft.brown_bundle": "Ruskea pussi",
  "item.minecraft.brown_dye": "Ruskea väriaine",
  "item.minecraft.brown_egg": "Ruskea muna",
  "item.minecraft.brown_harness": "Ruskeat valjaat",
  "item.minecraft.brush": "Sivellin",
  "item.minecraft.bucket": "Ämpäri",
  "item.minecraft.bundle": "Pussi",
  "item.minecraft.bundle.empty": "Tyhjä",
  "item.minecraft.bundle.empty.description": "Voi kantaa sekalaisen pinon esineitä",
  "item.minecraft.bundle.full": "Täysi",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Liekin ruukunsirpale",
  "item.minecraft.burn_pottery_sherd": "Liekin ruukunsirpale",
  "item.minecraft.camel_husk_spawn_egg": "Luo kameliholkki",
  "item.minecraft.camel_spawn_egg": "Luo kameli",
  "item.minecraft.carrot": "Porkkana",
  "item.minecraft.carrot_on_a_stick": "Porkkana kepin päässä",
  "item.minecraft.cat_spawn_egg": "Luo kissa",
  "item.minecraft.cauldron": "Pata",
  "item.minecraft.cave_spider_spawn_egg": "Luo luolahämähäkki",
  "item.minecraft.chainmail_boots": "Rengashaarniskan saappaat",
  "item.minecraft.chainmail_chestplate": "Rengashaarniskan rintapanssari",
  "item.minecraft.chainmail_helmet": "Rengashaarniskan kypärä",
  "item.minecraft.chainmail_leggings": "Rengashaarniskan housut",
  "item.minecraft.charcoal": "Puuhiili",
  "item.minecraft.cherry_boat": "Kirsikkapuuvene",
  "item.minecraft.cherry_chest_boat": "Kirsikkapuuvene arkulla",
  "item.minecraft.chest_minecart": "Arkullinen kaivosvaunu",
  "item.minecraft.chicken": "Raaka kana",
  "item.minecraft.chicken_spawn_egg": "Luo kana",
  "item.minecraft.chorus_fruit": "Chorus-hedelmä",
  "item.minecraft.clay_ball": "Savipallo",
  "item.minecraft.clock": "Kello",
  "item.minecraft.coal": "Hiili",
  "item.minecraft.coast_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Rannikon haarniskakoristeet",
  "item.minecraft.cocoa_beans": "Kaakaopavut",
  "item.minecraft.cod": "Raaka turska",
  "item.minecraft.cod_bucket": "Turska ämpärissä",
  "item.minecraft.cod_spawn_egg": "Luo turska",
  "item.minecraft.command_block_minecart": "Komentokuutiokaivosvaunu",
  "item.minecraft.compass": "Kompassi",
  "item.minecraft.cooked_beef": "Paisti",
  "item.minecraft.cooked_chicken": "Paistettu kana",
  "item.minecraft.cooked_cod": "Paistettu turska",
  "item.minecraft.cooked_mutton": "Paistettu lampaanliha",
  "item.minecraft.cooked_porkchop": "Paistettu porsaankyljys",
  "item.minecraft.cooked_rabbit": "Paistettu jäniksenliha",
  "item.minecraft.cooked_salmon": "Paistettu lohi",
  "item.minecraft.cookie": "Keksi",
  "item.minecraft.copper_axe": "Kuparikirves",
  "item.minecraft.copper_boots": "Kuparisaappaat",
  "item.minecraft.copper_chestplate": "Kuparirintapanssari",
  "item.minecraft.copper_golem_spawn_egg": "Luo kuparigolem",
  "item.minecraft.copper_helmet": "Kuparikypärä",
  "item.minecraft.copper_hoe": "Kuparikuokka",
  "item.minecraft.copper_horse_armor": "Kuparinen hevosen panssari",
  "item.minecraft.copper_ingot": "Kupariharkko",
  "item.minecraft.copper_leggings": "Kuparihousut",
  "item.minecraft.copper_nautilus_armor": "Kuparinen helmiveneen panssari",
  "item.minecraft.copper_nugget": "Kuparihippu",
  "item.minecraft.copper_pickaxe": "Kuparihakku",
  "item.minecraft.copper_shovel": "Kuparilapio",
  "item.minecraft.copper_spear": "Kuparikeihäs",
  "item.minecraft.copper_sword": "Kuparimiekka",
  "item.minecraft.cow_spawn_egg": "Luo lehmä",
  "item.minecraft.creaking_spawn_egg": "Luo narahtelija",
  "item.minecraft.creeper_banner_pattern": "Viirikuvio",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-viirikuvio",
  "item.minecraft.creeper_spawn_egg": "Luo creeper",
  "item.minecraft.crossbow": "Varsijousi",
  "item.minecraft.crossbow.projectile": "Ammus:",
  "item.minecraft.crossbow.projectile.multiple": "Ammus: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Ammus: %s",
  "item.minecraft.cyan_bundle": "Syaani pussi",
  "item.minecraft.cyan_dye": "Syaani väriaine",
  "item.minecraft.cyan_harness": "Syaanit valjaat",
  "item.minecraft.danger_pottery_shard": "Vaaran ruukunsirpale",
  "item.minecraft.danger_pottery_sherd": "Vaaran ruukunsirpale",
  "item.minecraft.dark_oak_boat": "Tumma tammivene",
  "item.minecraft.dark_oak_chest_boat": "Tumma tammivene arkulla",
  "item.minecraft.debug_stick": "Virheenkorjaustikku",
  "item.minecraft.debug_stick.empty": "Kohteella %s ei ole ominaisuuksia",
  "item.minecraft.debug_stick.select": "valittu \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" tilaan %s",
  "item.minecraft.diamond": "Timantti",
  "item.minecraft.diamond_axe": "Timanttikirves",
  "item.minecraft.diamond_boots": "Timanttisaappaat",
  "item.minecraft.diamond_chestplate": "Timanttirintapanssari",
  "item.minecraft.diamond_helmet": "Timanttikypärä",
  "item.minecraft.diamond_hoe": "Timanttikuokka",
  "item.minecraft.diamond_horse_armor": "Timanttinen hevosen panssari",
  "item.minecraft.diamond_leggings": "Timanttihousut",
  "item.minecraft.diamond_nautilus_armor": "Timanttinen helmiveneen panssari",
  "item.minecraft.diamond_pickaxe": "Timanttihakku",
  "item.minecraft.diamond_shovel": "Timanttilapio",
  "item.minecraft.diamond_spear": "Timanttikeihäs",
  "item.minecraft.diamond_sword": "Timanttimiekka",
  "item.minecraft.disc_fragment_5": "Musiikkilevyn palanen",
  "item.minecraft.disc_fragment_5.desc": "Musiikkilevy – 5",
  "item.minecraft.dolphin_spawn_egg": "Luo delfiini",
  "item.minecraft.donkey_spawn_egg": "Luo aasi",
  "item.minecraft.dragon_breath": "Lohikäärmeen henkäys",
  "item.minecraft.dried_kelp": "Kuivattu rakkolevä",
  "item.minecraft.drowned_spawn_egg": "Luo hukkunut",
  "item.minecraft.dune_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dyynien haarniskakoristeet",
  "item.minecraft.echo_shard": "Kaikusirpale",
  "item.minecraft.egg": "Kananmuna",
  "item.minecraft.elder_guardian_spawn_egg": "Luo vartijavanhin",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragdi",
  "item.minecraft.enchanted_book": "Lumottu kirja",
  "item.minecraft.enchanted_golden_apple": "Lumottu kultaomena",
  "item.minecraft.end_crystal": "End-kristalli",
  "item.minecraft.ender_dragon_spawn_egg": "Luo ender-lohikäärme",
  "item.minecraft.ender_eye": "Ender-silmä",
  "item.minecraft.ender_pearl": "Ender-helmi",
  "item.minecraft.enderman_spawn_egg": "Luo enderman",
  "item.minecraft.endermite_spawn_egg": "Luo endermite",
  "item.minecraft.evoker_spawn_egg": "Luo manaaja",
  "item.minecraft.experience_bottle": "Lumottu pullo",
  "item.minecraft.explorer_pottery_shard": "Seikkailijan ruukunsirpale",
  "item.minecraft.explorer_pottery_sherd": "Seikkailijan ruukunsirpale",
  "item.minecraft.eye_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Silmän haarniskakoristeet",
  "item.minecraft.feather": "Höyhen",
  "item.minecraft.fermented_spider_eye": "Käynyt hämähäkinsilmä",
  "item.minecraft.field_masoned_banner_pattern": "Tiilikuvioinen viirikuvio",
  "item.minecraft.filled_map": "Kartta",
  "item.minecraft.fire_charge": "Tulipallo",
  "item.minecraft.firework_rocket": "Ilotulitusraketti",
  "item.minecraft.firework_rocket.flight": "Lentoaika:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Ilotulituspanos",
  "item.minecraft.firework_star.black": "Musta",
  "item.minecraft.firework_star.blue": "Sininen",
  "item.minecraft.firework_star.brown": "Ruskea",
  "item.minecraft.firework_star.custom_color": "Oma väri",
  "item.minecraft.firework_star.cyan": "Syaani",
  "item.minecraft.firework_star.fade_to": "Häivytys",
  "item.minecraft.firework_star.flicker": "Tuike",
  "item.minecraft.firework_star.gray": "Harmaa",
  "item.minecraft.firework_star.green": "Vihreä",
  "item.minecraft.firework_star.light_blue": "Vaaleansininen",
  "item.minecraft.firework_star.light_gray": "Vaaleanharmaa",
  "item.minecraft.firework_star.lime": "Limetinvihreä",
  "item.minecraft.firework_star.magenta": "Purppura",
  "item.minecraft.firework_star.orange": "Oranssi",
  "item.minecraft.firework_star.pink": "Vaaleanpunainen",
  "item.minecraft.firework_star.purple": "Violetti",
  "item.minecraft.firework_star.red": "Punainen",
  "item.minecraft.firework_star.shape": "Tuntematon kuvio",
  "item.minecraft.firework_star.shape.burst": "Ryöppy",
  "item.minecraft.firework_star.shape.creeper": "Creeper-kuvioitu",
  "item.minecraft.firework_star.shape.large_ball": "Suuri räjähdys",
  "item.minecraft.firework_star.shape.small_ball": "Pieni räjähdys",
  "item.minecraft.firework_star.shape.star": "Tähtikuvio",
  "item.minecraft.firework_star.trail": "Vana",
  "item.minecraft.firework_star.white": "Valkoinen",
  "item.minecraft.firework_star.yellow": "Keltainen",
  "item.minecraft.fishing_rod": "Onkivapa",
  "item.minecraft.flint": "Piikivi",
  "item.minecraft.flint_and_steel": "Tulukset",
  "item.minecraft.flow_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Virtauksen haarniskakoristeet",
  "item.minecraft.flow_banner_pattern": "Viirikuvio",
  "item.minecraft.flow_banner_pattern.desc": "Virtaus",
  "item.minecraft.flow_banner_pattern.new": "Virtausviirikuvio",
  "item.minecraft.flow_pottery_sherd": "Virtauksen ruukunsirpale",
  "item.minecraft.flower_banner_pattern": "Viirikuvio",
  "item.minecraft.flower_banner_pattern.desc": "Kukka",
  "item.minecraft.flower_banner_pattern.new": "Kukkaviirikuvio",
  "item.minecraft.flower_pot": "Kukkaruukku",
  "item.minecraft.fox_spawn_egg": "Luo kettu",
  "item.minecraft.friend_pottery_shard": "Ystävän ruukunsirpale",
  "item.minecraft.friend_pottery_sherd": "Ystävän ruukunsirpale",
  "item.minecraft.frog_spawn_egg": "Luo sammakko",
  "item.minecraft.furnace_minecart": "Moottoroitu kaivosvaunu",
  "item.minecraft.ghast_spawn_egg": "Luo ghast",
  "item.minecraft.ghast_tear": "Ghastin kyynel",
  "item.minecraft.glass_bottle": "Lasipullo",
  "item.minecraft.glistering_melon_slice": "Kimalteleva melonin siivu",
  "item.minecraft.globe_banner_pattern": "Viirikuvio",
  "item.minecraft.globe_banner_pattern.desc": "Karttakuutio",
  "item.minecraft.globe_banner_pattern.new": "Karttakuutioviirikuvio",
  "item.minecraft.glow_berries": "Hehkumarjat",
  "item.minecraft.glow_ink_sac": "Hehkumustepussi",
  "item.minecraft.glow_item_frame": "Hehkukehys",
  "item.minecraft.glow_squid_spawn_egg": "Luo hehkukalmari",
  "item.minecraft.glowstone_dust": "Hehkukivijauhe",
  "item.minecraft.goat_horn": "Vuohen sarvi",
  "item.minecraft.goat_spawn_egg": "Luo vuohi",
  "item.minecraft.gold_ingot": "Kultaharkko",
  "item.minecraft.gold_nugget": "Kultahippu",
  "item.minecraft.golden_apple": "Kultaomena",
  "item.minecraft.golden_axe": "Kultakirves",
  "item.minecraft.golden_boots": "Kultasaappaat",
  "item.minecraft.golden_carrot": "Kultaporkkana",
  "item.minecraft.golden_chestplate": "Kultarintapanssari",
  "item.minecraft.golden_helmet": "Kultakypärä",
  "item.minecraft.golden_hoe": "Kultakuokka",
  "item.minecraft.golden_horse_armor": "Kultainen hevosen panssari",
  "item.minecraft.golden_leggings": "Kultahousut",
  "item.minecraft.golden_nautilus_armor": "Kultainen helmiveneen panssari",
  "item.minecraft.golden_pickaxe": "Kultahakku",
  "item.minecraft.golden_shovel": "Kultalapio",
  "item.minecraft.golden_spear": "Kultakeihäs",
  "item.minecraft.golden_sword": "Kultamiekka",
  "item.minecraft.gray_bundle": "Harmaa pussi",
  "item.minecraft.gray_dye": "Harmaa väriaine",
  "item.minecraft.gray_harness": "Harmaat valjaat",
  "item.minecraft.green_bundle": "Vihreä pussi",
  "item.minecraft.green_dye": "Vihreä väriaine",
  "item.minecraft.green_harness": "Vihreät valjaat",
  "item.minecraft.guardian_spawn_egg": "Luo vartija",
  "item.minecraft.gunpowder": "Ruuti",
  "item.minecraft.guster_banner_pattern": "Viirikuvio",
  "item.minecraft.guster_banner_pattern.desc": "Tuulahdus",
  "item.minecraft.guster_banner_pattern.new": "Tuulahdusviirikuvio",
  "item.minecraft.guster_pottery_sherd": "Tuulahduksen ruukunsirpale",
  "item.minecraft.happy_ghast_spawn_egg": "Luo iloinen ghast",
  "item.minecraft.harness": "Valjaat",
  "item.minecraft.heart_of_the_sea": "Meren sydän",
  "item.minecraft.heart_pottery_shard": "Sydämen ruukunsirpale",
  "item.minecraft.heart_pottery_sherd": "Sydämen ruukunsirpale",
  "item.minecraft.heartbreak_pottery_shard": "Särkyneen sydämen ruukunsirpale",
  "item.minecraft.heartbreak_pottery_sherd": "Särkyneen sydämen ruukunsirpale",
  "item.minecraft.hoglin_spawn_egg": "Luo hoglin",
  "item.minecraft.honey_bottle": "Hunajapullo",
  "item.minecraft.honeycomb": "Hunajakenno",
  "item.minecraft.hopper_minecart": "Suppilokaivosvaunu",
  "item.minecraft.horse_spawn_egg": "Luo hevonen",
  "item.minecraft.host_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.host_armor_trim_smithing_template.new": "Majapaikan haarniskakoristeet",
  "item.minecraft.howl_pottery_shard": "Ulvojan ruukunsirpale",
  "item.minecraft.howl_pottery_sherd": "Ulvojan ruukunsirpale",
  "item.minecraft.husk_spawn_egg": "Luo holkki",
  "item.minecraft.ink_sac": "Mustepussi",
  "item.minecraft.iron_axe": "Rautakirves",
  "item.minecraft.iron_boots": "Rautasaappaat",
  "item.minecraft.iron_chestplate": "Rautarintapanssari",
  "item.minecraft.iron_golem_spawn_egg": "Luo rautagolem",
  "item.minecraft.iron_helmet": "Rautakypärä",
  "item.minecraft.iron_hoe": "Rautakuokka",
  "item.minecraft.iron_horse_armor": "Rautainen hevosen panssari",
  "item.minecraft.iron_ingot": "Rautaharkko",
  "item.minecraft.iron_leggings": "Rautahousut",
  "item.minecraft.iron_nautilus_armor": "Rautainen helmiveneen panssari",
  "item.minecraft.iron_nugget": "Rautahippu",
  "item.minecraft.iron_pickaxe": "Rautahakku",
  "item.minecraft.iron_shovel": "Rautalapio",
  "item.minecraft.iron_spear": "Rautakeihäs",
  "item.minecraft.iron_sword": "Rautamiekka",
  "item.minecraft.item_frame": "Kehys",
  "item.minecraft.jungle_boat": "Viidakkopuuvene",
  "item.minecraft.jungle_chest_boat": "Viidakkopuuvene arkulla",
  "item.minecraft.knowledge_book": "Tietokirja",
  "item.minecraft.lapis_lazuli": "Lasuriitti",
  "item.minecraft.lava_bucket": "Laavaämpäri",
  "item.minecraft.lead": "Talutushihna",
  "item.minecraft.leather": "Nahka",
  "item.minecraft.leather_boots": "Nahkasaappaat",
  "item.minecraft.leather_chestplate": "Nahkatakki",
  "item.minecraft.leather_helmet": "Nahkalakki",
  "item.minecraft.leather_horse_armor": "Nahkainen hevosen panssari",
  "item.minecraft.leather_leggings": "Nahkahousut",
  "item.minecraft.light_blue_bundle": "Vaaleansininen pussi",
  "item.minecraft.light_blue_dye": "Vaaleansininen väriaine",
  "item.minecraft.light_blue_harness": "Vaaleansiniset valjaat",
  "item.minecraft.light_gray_bundle": "Vaaleanharmaa pussi",
  "item.minecraft.light_gray_dye": "Vaaleanharmaa väriaine",
  "item.minecraft.light_gray_harness": "Vaaleanharmaat valjaat",
  "item.minecraft.lime_bundle": "Limetinvihreä pussi",
  "item.minecraft.lime_dye": "Limetinvihreä väriaine",
  "item.minecraft.lime_harness": "Limetinvihreät valjaat",
  "item.minecraft.lingering_potion": "Viipyvä taikajuoma",
  "item.minecraft.lingering_potion.effect.awkward": "Kiusallinen viipyvä taikajuoma",
  "item.minecraft.lingering_potion.effect.empty": "Valmistuskelvoton viipyvä taikajuoma",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Viipyvä tulenkestävyyden taikajuoma",
  "item.minecraft.lingering_potion.effect.harming": "Viipyvä vahingoittava taikajuoma",
  "item.minecraft.lingering_potion.effect.healing": "Viipyvä parantava taikajuoma",
  "item.minecraft.lingering_potion.effect.infested": "Viipyvä saastumisen taikajuoma",
  "item.minecraft.lingering_potion.effect.invisibility": "Viipyvä näkymättömyyden taikajuoma",
  "item.minecraft.lingering_potion.effect.leaping": "Viipyvä loikkaamisen taikajuoma",
  "item.minecraft.lingering_potion.effect.levitation": "Viipyvä levitaation taikajuoma",
  "item.minecraft.lingering_potion.effect.luck": "Viipyvä onnen taikajuoma",
  "item.minecraft.lingering_potion.effect.mundane": "Tavanomainen viipyvä taikajuoma",
  "item.minecraft.lingering_potion.effect.night_vision": "Viipyvä hämäränäön taikajuoma",
  "item.minecraft.lingering_potion.effect.oozing": "Viipyvä limaisuuden taikajuoma",
  "item.minecraft.lingering_potion.effect.poison": "Viipyvä myrkyllinen taikajuoma",
  "item.minecraft.lingering_potion.effect.regeneration": "Viipyvä elpymisen taikajuoma",
  "item.minecraft.lingering_potion.effect.slow_falling": "Viipyvä hitaan putoamisen taikajuoma",
  "item.minecraft.lingering_potion.effect.slowness": "Viipyvä hitauden taikajuoma",
  "item.minecraft.lingering_potion.effect.strength": "Viipyvä vahvuuden taikajuoma",
  "item.minecraft.lingering_potion.effect.swiftness": "Viipyvä nopeuden taikajuoma",
  "item.minecraft.lingering_potion.effect.thick": "Sakea viipyvä taikajuoma",
  "item.minecraft.lingering_potion.effect.turtle_master": "Viipyvä kilpikonnamestarin taikajuoma",
  "item.minecraft.lingering_potion.effect.water": "Viipyvä vesipullo",
  "item.minecraft.lingering_potion.effect.water_breathing": "Viipyvä vedenhengityksen taikajuoma",
  "item.minecraft.lingering_potion.effect.weakness": "Viipyvä heikkouden taikajuoma",
  "item.minecraft.lingering_potion.effect.weaving": "Viipyvä kutomisen taikajuoma",
  "item.minecraft.lingering_potion.effect.wind_charged": "Viipyvä tuulilatauksen taikajuoma",
  "item.minecraft.llama_spawn_egg": "Luo laama",
  "item.minecraft.lodestone_compass": "Magneettikivikompassi",
  "item.minecraft.mace": "Nuija",
  "item.minecraft.magenta_bundle": "Purppura pussi",
  "item.minecraft.magenta_dye": "Purppura väriaine",
  "item.minecraft.magenta_harness": "Purppurat valjaat",
  "item.minecraft.magma_cream": "Magmavoide",
  "item.minecraft.magma_cube_spawn_egg": "Luo magmakuutio",
  "item.minecraft.mangrove_boat": "Mangrovepuuvene",
  "item.minecraft.mangrove_chest_boat": "Mangrovepuuvene arkulla",
  "item.minecraft.map": "Tyhjä kartta",
  "item.minecraft.melon_seeds": "Melonin siemenet",
  "item.minecraft.melon_slice": "Melonin siivu",
  "item.minecraft.milk_bucket": "Maitoämpäri",
  "item.minecraft.minecart": "Kaivosvaunu",
  "item.minecraft.miner_pottery_shard": "Kaivoksen ruukunsirpale",
  "item.minecraft.miner_pottery_sherd": "Kaivoksen ruukunsirpale",
  "item.minecraft.mojang_banner_pattern": "Viirikuvio",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-symboli",
  "item.minecraft.mojang_banner_pattern.new": "Mojang-viirikuvio",
  "item.minecraft.mooshroom_spawn_egg": "Luo mooshroom",
  "item.minecraft.mourner_pottery_shard": "Surevan ruukunsirpale",
  "item.minecraft.mourner_pottery_sherd": "Surevan ruukunsirpale",
  "item.minecraft.mule_spawn_egg": "Luo muuli",
  "item.minecraft.mushroom_stew": "Sienimuhennos",
  "item.minecraft.music_disc_11": "Musiikkilevy",
  "item.minecraft.music_disc_11.desc": "C418 –  11",
  "item.minecraft.music_disc_13": "Musiikkilevy",
  "item.minecraft.music_disc_13.desc": "C418 –  13",
  "item.minecraft.music_disc_5": "Musiikkilevy",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg – 5",
  "item.minecraft.music_disc_blocks": "Musiikkilevy",
  "item.minecraft.music_disc_blocks.desc": "C418 –  blocks",
  "item.minecraft.music_disc_cat": "Musiikkilevy",
  "item.minecraft.music_disc_cat.desc": "C418 –  cat",
  "item.minecraft.music_disc_chirp": "Musiikkilevy",
  "item.minecraft.music_disc_chirp.desc": "C418 –  chirp",
  "item.minecraft.music_disc_creator": "Musiikkilevy",
  "item.minecraft.music_disc_creator.desc": "Lena Raine – Creator",
  "item.minecraft.music_disc_creator_music_box": "Musiikkilevy",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine – Creator (Music Box)",
  "item.minecraft.music_disc_far": "Musiikkilevy",
  "item.minecraft.music_disc_far.desc": "C418 –  far",
  "item.minecraft.music_disc_lava_chicken": "Musiikkilevy",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions – Lava Chicken",
  "item.minecraft.music_disc_mall": "Musiikkilevy",
  "item.minecraft.music_disc_mall.desc": "C418 –  mall",
  "item.minecraft.music_disc_mellohi": "Musiikkilevy",
  "item.minecraft.music_disc_mellohi.desc": "C418 –  mellohi",
  "item.minecraft.music_disc_otherside": "Musiikkilevy",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Musiikkilevy",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine – Pigstep",
  "item.minecraft.music_disc_precipice": "Musiikkilevy",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof – Precipice",
  "item.minecraft.music_disc_relic": "Musiikkilevy",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof – Relic",
  "item.minecraft.music_disc_stal": "Musiikkilevy",
  "item.minecraft.music_disc_stal.desc": "C418 –  stal",
  "item.minecraft.music_disc_strad": "Musiikkilevy",
  "item.minecraft.music_disc_strad.desc": "C418 –  strad",
  "item.minecraft.music_disc_tears": "Musiikkilevy",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musiikkilevy",
  "item.minecraft.music_disc_wait.desc": "C418 –  wait",
  "item.minecraft.music_disc_ward": "Musiikkilevy",
  "item.minecraft.music_disc_ward.desc": "C418 –  ward",
  "item.minecraft.mutton": "Raaka lampaanliha",
  "item.minecraft.name_tag": "Nimilappu",
  "item.minecraft.nautilus_shell": "Helmiveneen kuori",
  "item.minecraft.nautilus_spawn_egg": "Luo helmivene",
  "item.minecraft.nether_brick": "Nether-tiili",
  "item.minecraft.nether_star": "Nether-tähti",
  "item.minecraft.nether_wart": "Nether-pahka",
  "item.minecraft.netherite_axe": "Netheriittikirves",
  "item.minecraft.netherite_boots": "Netheriittisaappaat",
  "item.minecraft.netherite_chestplate": "Netheriittirintapanssari",
  "item.minecraft.netherite_helmet": "Netheriittikypärä",
  "item.minecraft.netherite_hoe": "Netheriittikuokka",
  "item.minecraft.netherite_horse_armor": "Netheriittinen hevosen panssari",
  "item.minecraft.netherite_ingot": "Netheriittiharkko",
  "item.minecraft.netherite_leggings": "Netheriittihousut",
  "item.minecraft.netherite_nautilus_armor": "Netheriittinen helmiveneen panssari",
  "item.minecraft.netherite_pickaxe": "Netheriittihakku",
  "item.minecraft.netherite_scrap": "Netheriittiromu",
  "item.minecraft.netherite_shovel": "Netheriittilapio",
  "item.minecraft.netherite_spear": "Netheriittikeihäs",
  "item.minecraft.netherite_sword": "Netheriittimiekka",
  "item.minecraft.netherite_upgrade_smithing_template": "Taontamalli",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheriittipäivitys",
  "item.minecraft.oak_boat": "Tammivene",
  "item.minecraft.oak_chest_boat": "Tammivene arkulla",
  "item.minecraft.ocelot_spawn_egg": "Luo oselotti",
  "item.minecraft.ominous_bottle": "Pahaenteinen pullo",
  "item.minecraft.ominous_trial_key": "Pahaenteinen koetuksen avain",
  "item.minecraft.orange_bundle": "Oranssi pussi",
  "item.minecraft.orange_dye": "Oranssi väriaine",
  "item.minecraft.orange_harness": "Oranssit valjaat",
  "item.minecraft.painting": "Maalaus",
  "item.minecraft.pale_oak_boat": "Kalvastammivene",
  "item.minecraft.pale_oak_chest_boat": "Kalvastammivene arkulla",
  "item.minecraft.panda_spawn_egg": "Luo panda",
  "item.minecraft.paper": "Paperi",
  "item.minecraft.parched_spawn_egg": "Luo kuivahtanut",
  "item.minecraft.parrot_spawn_egg": "Luo papukaija",
  "item.minecraft.phantom_membrane": "Aaveen kalvo",
  "item.minecraft.phantom_spawn_egg": "Luo aave",
  "item.minecraft.pig_spawn_egg": "Luo sika",
  "item.minecraft.piglin_banner_pattern": "Viirikuvio",
  "item.minecraft.piglin_banner_pattern.desc": "Kärsä",
  "item.minecraft.piglin_banner_pattern.new": "Kärsäviirikuvio",
  "item.minecraft.piglin_brute_spawn_egg": "Luo piglin-raakalainen",
  "item.minecraft.piglin_spawn_egg": "Luo piglin",
  "item.minecraft.pillager_spawn_egg": "Luo ryöstäjä",
  "item.minecraft.pink_bundle": "Vaaleanpunainen pussi",
  "item.minecraft.pink_dye": "Vaaleanpunainen väriaine",
  "item.minecraft.pink_harness": "Vaaleanpunaiset valjaat",
  "item.minecraft.pitcher_plant": "Sinikannu",
  "item.minecraft.pitcher_pod": "Sinikannun palko",
  "item.minecraft.plenty_pottery_shard": "Runsauden ruukunsirpale",
  "item.minecraft.plenty_pottery_sherd": "Runsauden ruukunsirpale",
  "item.minecraft.poisonous_potato": "Myrkyllinen peruna",
  "item.minecraft.polar_bear_spawn_egg": "Luo jääkarhu",
  "item.minecraft.popped_chorus_fruit": "Paistettu Chorus-hedelmä",
  "item.minecraft.porkchop": "Raaka porsaankyljys",
  "item.minecraft.potato": "Peruna",
  "item.minecraft.potion": "Taikajuoma",
  "item.minecraft.potion.effect.awkward": "Kiusallinen taikajuoma",
  "item.minecraft.potion.effect.empty": "Valmistuskelvoton taikajuoma",
  "item.minecraft.potion.effect.fire_resistance": "Tulenkestävyyden taikajuoma",
  "item.minecraft.potion.effect.harming": "Vahingoittava taikajuoma",
  "item.minecraft.potion.effect.healing": "Parantava taikajuoma",
  "item.minecraft.potion.effect.infested": "Saastumisen taikajuoma",
  "item.minecraft.potion.effect.invisibility": "Näkymättömyyden taikajuoma",
  "item.minecraft.potion.effect.leaping": "Loikkaamisen taikajuoma",
  "item.minecraft.potion.effect.levitation": "Levitaation taikajuoma",
  "item.minecraft.potion.effect.luck": "Onnen taikajuoma",
  "item.minecraft.potion.effect.mundane": "Tavanomainen taikajuoma",
  "item.minecraft.potion.effect.night_vision": "Hämäränäön taikajuoma",
  "item.minecraft.potion.effect.oozing": "Limaisuuden taikajuoma",
  "item.minecraft.potion.effect.poison": "Myrkyllinen taikajuoma",
  "item.minecraft.potion.effect.regeneration": "Elpymisen taikajuoma",
  "item.minecraft.potion.effect.slow_falling": "Hitaan putoamisen taikajuoma",
  "item.minecraft.potion.effect.slowness": "Hitauden taikajuoma",
  "item.minecraft.potion.effect.strength": "Vahvuuden taikajuoma",
  "item.minecraft.potion.effect.swiftness": "Nopeuden taikajuoma",
  "item.minecraft.potion.effect.thick": "Sakea taikajuoma",
  "item.minecraft.potion.effect.turtle_master": "Kilpikonnamestarin taikajuoma",
  "item.minecraft.potion.effect.water": "Vesipullo",
  "item.minecraft.potion.effect.water_breathing": "Vedenhengityksen taikajuoma",
  "item.minecraft.potion.effect.weakness": "Heikkouden taikajuoma",
  "item.minecraft.potion.effect.weaving": "Kutomisen taikajuoma",
  "item.minecraft.potion.effect.wind_charged": "Tuulilatauksen taikajuoma",
  "item.minecraft.pottery_shard_archer": "Jousiampujan ruukunsirpale",
  "item.minecraft.pottery_shard_arms_up": "Soturin ruukunsirpale",
  "item.minecraft.pottery_shard_prize": "Aarteen ruukunsirpale",
  "item.minecraft.pottery_shard_skull": "Kallon ruukunsirpale",
  "item.minecraft.powder_snow_bucket": "Puuterilumiämpäri",
  "item.minecraft.prismarine_crystals": "Prismariinikristallit",
  "item.minecraft.prismarine_shard": "Prismariinisirpale",
  "item.minecraft.prize_pottery_shard": "Aarteen ruukunsirpale",
  "item.minecraft.prize_pottery_sherd": "Aarteen ruukunsirpale",
  "item.minecraft.pufferfish": "Pallokala",
  "item.minecraft.pufferfish_bucket": "Pallokala ämpärissä",
  "item.minecraft.pufferfish_spawn_egg": "Luo pallokala",
  "item.minecraft.pumpkin_pie": "Kurpitsapiirakka",
  "item.minecraft.pumpkin_seeds": "Kurpitsan siemenet",
  "item.minecraft.purple_bundle": "Violetti pussi",
  "item.minecraft.purple_dye": "Violetti väriaine",
  "item.minecraft.purple_harness": "Violetit valjaat",
  "item.minecraft.quartz": "Nether-kvartsi",
  "item.minecraft.rabbit": "Raaka jäniksenliha",
  "item.minecraft.rabbit_foot": "Jäniksenkäpälä",
  "item.minecraft.rabbit_hide": "Jäniksen nahka",
  "item.minecraft.rabbit_spawn_egg": "Luo jänis",
  "item.minecraft.rabbit_stew": "Jänismuhennos",
  "item.minecraft.raiser_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Kohottajan haarniskakoristeet",
  "item.minecraft.ravager_spawn_egg": "Luo raunioittaja",
  "item.minecraft.raw_copper": "Raaka kupari",
  "item.minecraft.raw_gold": "Raaka kulta",
  "item.minecraft.raw_iron": "Raaka rauta",
  "item.minecraft.recovery_compass": "Paluukompassi",
  "item.minecraft.red_bundle": "Punainen pussi",
  "item.minecraft.red_dye": "Punainen väriaine",
  "item.minecraft.red_harness": "Punaiset valjaat",
  "item.minecraft.redstone": "Redstone-jauhe",
  "item.minecraft.resin_brick": "Pihkatiili",
  "item.minecraft.resin_clump": "Pihkakimpale",
  "item.minecraft.rib_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Kylkiluiden haarniskakoristeet",
  "item.minecraft.rotten_flesh": "Mädäntynyt liha",
  "item.minecraft.saddle": "Satula",
  "item.minecraft.salmon": "Raaka lohi",
  "item.minecraft.salmon_bucket": "Lohi ämpärissä",
  "item.minecraft.salmon_spawn_egg": "Luo lohi",
  "item.minecraft.scrape_pottery_sherd": "Raaputuksen ruukunsirpale",
  "item.minecraft.scute": "Suomu",
  "item.minecraft.sentry_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Vartion haarniskakoristeet",
  "item.minecraft.shaper_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Valajan haarniskakoristeet",
  "item.minecraft.sheaf_pottery_shard": "Lyhteen ruukunsirpale",
  "item.minecraft.sheaf_pottery_sherd": "Lyhteen ruukunsirpale",
  "item.minecraft.shears": "Keritsimet",
  "item.minecraft.sheep_spawn_egg": "Luo lammas",
  "item.minecraft.shelter_pottery_shard": "Suojan ruukunsirpale",
  "item.minecraft.shelter_pottery_sherd": "Suojan ruukunsirpale",
  "item.minecraft.shield": "Kilpi",
  "item.minecraft.shield.black": "Musta kilpi",
  "item.minecraft.shield.blue": "Sininen kilpi",
  "item.minecraft.shield.brown": "Ruskea kilpi",
  "item.minecraft.shield.cyan": "Syaani kilpi",
  "item.minecraft.shield.gray": "Harmaa kilpi",
  "item.minecraft.shield.green": "Vihreä kilpi",
  "item.minecraft.shield.light_blue": "Vaaleansininen kilpi",
  "item.minecraft.shield.light_gray": "Vaaleanharmaa kilpi",
  "item.minecraft.shield.lime": "Limetinvihreä kilpi",
  "item.minecraft.shield.magenta": "Purppura kilpi",
  "item.minecraft.shield.orange": "Oranssi kilpi",
  "item.minecraft.shield.pink": "Vaaleanpunainen kilpi",
  "item.minecraft.shield.purple": "Violetti kilpi",
  "item.minecraft.shield.red": "Punainen kilpi",
  "item.minecraft.shield.white": "Valkoinen kilpi",
  "item.minecraft.shield.yellow": "Keltainen kilpi",
  "item.minecraft.shulker_shell": "Shulkerin kuori",
  "item.minecraft.shulker_spawn_egg": "Luo shulker",
  "item.minecraft.sign": "Kyltti",
  "item.minecraft.silence_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Hiljaisuuden haarniskakoristeet",
  "item.minecraft.silverfish_spawn_egg": "Luo sokeritoukka",
  "item.minecraft.skeleton_horse_spawn_egg": "Luo luurankohevonen",
  "item.minecraft.skeleton_spawn_egg": "Luo luuranko",
  "item.minecraft.skull_banner_pattern": "Viirikuvio",
  "item.minecraft.skull_banner_pattern.desc": "Pääkallo",
  "item.minecraft.skull_banner_pattern.new": "Pääkalloviirikuvio",
  "item.minecraft.skull_pottery_shard": "Kallon ruukunsirpale",
  "item.minecraft.skull_pottery_sherd": "Kallon ruukunsirpale",
  "item.minecraft.slime_ball": "Limapallo",
  "item.minecraft.slime_spawn_egg": "Luo lima",
  "item.minecraft.smithing_template": "Taontamalli",
  "item.minecraft.smithing_template.applies_to": "Kohde:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Lisää harkko tai kristalli",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Haarniska",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Lisää haarniskan osa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Harkot ja kristallit",
  "item.minecraft.smithing_template.ingredients": "Ainesosat:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Lisää netheriittiharkko",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Timanttivaruste",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Lisää timanttihaarniskan osa, ase tai työkalu",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheriittiharkko",
  "item.minecraft.smithing_template.upgrade": "Päivitys: ",
  "item.minecraft.sniffer_spawn_egg": "Luo nuuhku",
  "item.minecraft.snort_pottery_shard": "Nuuhkauksen ruukunsirpale",
  "item.minecraft.snort_pottery_sherd": "Nuuhkauksen ruukunsirpale",
  "item.minecraft.snout_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Kärsäin haarniskakoristeet",
  "item.minecraft.snow_golem_spawn_egg": "Luo lumigolem",
  "item.minecraft.snowball": "Lumipallo",
  "item.minecraft.spectral_arrow": "Spektraalinuoli",
  "item.minecraft.spider_eye": "Hämähäkinsilmä",
  "item.minecraft.spider_spawn_egg": "Luo hämähäkki",
  "item.minecraft.spire_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Tornin haarniskakoristeet",
  "item.minecraft.splash_potion": "Roiskahtava taikajuoma",
  "item.minecraft.splash_potion.effect.awkward": "Kiusallinen roiskahtava taikajuoma",
  "item.minecraft.splash_potion.effect.empty": "Valmistuskelvoton roiskahtava taikajuoma",
  "item.minecraft.splash_potion.effect.fire_resistance": "Roiskahtava tulenkestävyyden taikajuoma",
  "item.minecraft.splash_potion.effect.harming": "Roiskahtava vahingoittava taikajuoma",
  "item.minecraft.splash_potion.effect.healing": "Roiskahtava parantava taikajuoma",
  "item.minecraft.splash_potion.effect.infested": "Roiskahtava saastumisen taikajuoma",
  "item.minecraft.splash_potion.effect.invisibility": "Roiskahtava näkymättömyyden taikajuoma",
  "item.minecraft.splash_potion.effect.leaping": "Roiskahtava loikkaamisen taikajuoma",
  "item.minecraft.splash_potion.effect.levitation": "Roiskahtava levitoinnin taikajuoma",
  "item.minecraft.splash_potion.effect.luck": "Roiskahtava onnen taikajuoma",
  "item.minecraft.splash_potion.effect.mundane": "Tavanomainen roiskahtava taikajuoma",
  "item.minecraft.splash_potion.effect.night_vision": "Roiskahtava hämäränäön taikajuoma",
  "item.minecraft.splash_potion.effect.oozing": "Roiskahtava limaisuuden taikajuoma",
  "item.minecraft.splash_potion.effect.poison": "Roiskahtava myrkyllinen taikajuoma",
  "item.minecraft.splash_potion.effect.regeneration": "Roiskahtava elpymisen taikajuoma",
  "item.minecraft.splash_potion.effect.slow_falling": "Roiskahtava hitaan putoamisen taikajuoma",
  "item.minecraft.splash_potion.effect.slowness": "Roiskahtava hitauden taikajuoma",
  "item.minecraft.splash_potion.effect.strength": "Roiskahtava vahvuuden taikajuoma",
  "item.minecraft.splash_potion.effect.swiftness": "Roiskahtava nopeuden taikajuoma",
  "item.minecraft.splash_potion.effect.thick": "Sakea roiskahtava taikajuoma",
  "item.minecraft.splash_potion.effect.turtle_master": "Roiskahtava kilpikonnamestarin taikajuoma",
  "item.minecraft.splash_potion.effect.water": "Roiskahtava vesipullo",
  "item.minecraft.splash_potion.effect.water_breathing": "Roiskahtava vedenhengityksen taikajuoma",
  "item.minecraft.splash_potion.effect.weakness": "Roiskahtava heikkouden taikajuoma",
  "item.minecraft.splash_potion.effect.weaving": "Roiskahtava kutomisen taikajuoma",
  "item.minecraft.splash_potion.effect.wind_charged": "Roiskahtava tuulilatauksen taikajuoma",
  "item.minecraft.spruce_boat": "Kuusivene",
  "item.minecraft.spruce_chest_boat": "Kuusivene arkulla",
  "item.minecraft.spyglass": "Kaukoputki",
  "item.minecraft.squid_spawn_egg": "Luo kalmari",
  "item.minecraft.stick": "Keppi",
  "item.minecraft.stone_axe": "Kivikirves",
  "item.minecraft.stone_hoe": "Kivikuokka",
  "item.minecraft.stone_pickaxe": "Kivihakku",
  "item.minecraft.stone_shovel": "Kivilapio",
  "item.minecraft.stone_spear": "Kivikeihäs",
  "item.minecraft.stone_sword": "Kivimiekka",
  "item.minecraft.stray_spawn_egg": "Luo vaeltaja",
  "item.minecraft.strider_spawn_egg": "Luo rämpijä",
  "item.minecraft.string": "Lanka",
  "item.minecraft.sugar": "Sokeri",
  "item.minecraft.suspicious_stew": "Epäilyttävä muhennos",
  "item.minecraft.sweet_berries": "Makeat marjat",
  "item.minecraft.tadpole_bucket": "Nuijapää ämpärissä",
  "item.minecraft.tadpole_spawn_egg": "Luo nuijapää",
  "item.minecraft.tide_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Vuorovetten haarniskakoristeet",
  "item.minecraft.tipped_arrow": "Kastettu nuoli",
  "item.minecraft.tipped_arrow.effect.awkward": "Kastettu nuoli",
  "item.minecraft.tipped_arrow.effect.empty": "Valmistuskelvoton kastettu nuoli",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Tulenkestävyyden nuoli",
  "item.minecraft.tipped_arrow.effect.harming": "Vahingoittava nuoli",
  "item.minecraft.tipped_arrow.effect.healing": "Parantava nuoli",
  "item.minecraft.tipped_arrow.effect.infested": "Saastunut nuoli",
  "item.minecraft.tipped_arrow.effect.invisibility": "Näkymättömyyden nuoli",
  "item.minecraft.tipped_arrow.effect.leaping": "Loikkaamisen nuoli",
  "item.minecraft.tipped_arrow.effect.levitation": "Levitaation nuoli",
  "item.minecraft.tipped_arrow.effect.luck": "Onnen nuoli",
  "item.minecraft.tipped_arrow.effect.mundane": "Kastettu nuoli",
  "item.minecraft.tipped_arrow.effect.night_vision": "Hämäränäön nuoli",
  "item.minecraft.tipped_arrow.effect.oozing": "Limainen nuoli",
  "item.minecraft.tipped_arrow.effect.poison": "Myrkkynuoli",
  "item.minecraft.tipped_arrow.effect.regeneration": "Elpymisen nuoli",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Hitaan putoamisen nuoli",
  "item.minecraft.tipped_arrow.effect.slowness": "Hitauden nuoli",
  "item.minecraft.tipped_arrow.effect.strength": "Vahvuuden nuoli",
  "item.minecraft.tipped_arrow.effect.swiftness": "Nopeuden nuoli",
  "item.minecraft.tipped_arrow.effect.thick": "Kastettu nuoli",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Kilpikonnamestarin nuoli",
  "item.minecraft.tipped_arrow.effect.water": "Roiskenuoli",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Vedenhengityksen nuoli",
  "item.minecraft.tipped_arrow.effect.weakness": "Heikkouden nuoli",
  "item.minecraft.tipped_arrow.effect.weaving": "Kutomisen nuoli",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Tuulilatauksen nuoli",
  "item.minecraft.tnt_minecart": "TNT-kaivosvaunu",
  "item.minecraft.torchflower_seeds": "Soihtuliljan siemenet",
  "item.minecraft.totem_of_undying": "Kuolemattomuuden toteemi",
  "item.minecraft.trader_llama_spawn_egg": "Luo kulkukauppiaan laama",
  "item.minecraft.trial_key": "Koetuksen avain",
  "item.minecraft.trident": "Atrain",
  "item.minecraft.tropical_fish": "Trooppinen kala",
  "item.minecraft.tropical_fish_bucket": "Trooppinen kala ämpärissä",
  "item.minecraft.tropical_fish_spawn_egg": "Luo trooppinen kala",
  "item.minecraft.turtle_helmet": "Kilpikonnan kuori",
  "item.minecraft.turtle_scute": "Kilpikonnan suomu",
  "item.minecraft.turtle_spawn_egg": "Luo kilpikonna",
  "item.minecraft.vex_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Piinan haarniskakoristeet",
  "item.minecraft.vex_spawn_egg": "Luo piina",
  "item.minecraft.villager_spawn_egg": "Luo kyläläinen",
  "item.minecraft.vindicator_spawn_egg": "Luo puhdistaja",
  "item.minecraft.wandering_trader_spawn_egg": "Luo kulkukauppias",
  "item.minecraft.ward_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Wardenin haarniskakoristeet",
  "item.minecraft.warden_spawn_egg": "Luo warden",
  "item.minecraft.warped_fungus_on_a_stick": "Kummasieni kepin päässä",
  "item.minecraft.water_bucket": "Vesiämpäri",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Tiennäyttäjän haarniskakoristeet",
  "item.minecraft.wheat": "Vehnä",
  "item.minecraft.wheat_seeds": "Vehnän siemenet",
  "item.minecraft.white_bundle": "Valkoinen pussi",
  "item.minecraft.white_dye": "Valkoinen väriaine",
  "item.minecraft.white_harness": "Valkoiset valjaat",
  "item.minecraft.wild_armor_trim_smithing_template": "Taontamalli",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Viidakon haarniskakoristeet",
  "item.minecraft.wind_charge": "Puhuripallo",
  "item.minecraft.witch_spawn_egg": "Luo noita",
  "item.minecraft.wither_skeleton_spawn_egg": "Luo wither-luuranko",
  "item.minecraft.wither_spawn_egg": "Luo wither",
  "item.minecraft.wolf_armor": "Suden haarniska",
  "item.minecraft.wolf_spawn_egg": "Luo susi",
  "item.minecraft.wooden_axe": "Puukirves",
  "item.minecraft.wooden_hoe": "Puukuokka",
  "item.minecraft.wooden_pickaxe": "Puuhakku",
  "item.minecraft.wooden_shovel": "Puulapio",
  "item.minecraft.wooden_spear": "Puukeihäs",
  "item.minecraft.wooden_sword": "Puumiekka",
  "item.minecraft.writable_book": "Kirja ja sulkakynä",
  "item.minecraft.written_book": "Kirjoitettu kirja",
  "item.minecraft.yellow_bundle": "Keltainen pussi",
  "item.minecraft.yellow_dye": "Keltainen väriaine",
  "item.minecraft.yellow_harness": "Keltaiset valjaat",
  "item.minecraft.zoglin_spawn_egg": "Luo zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Luo zombihevonen",
  "item.minecraft.zombie_nautilus_spawn_egg": "Luo zombihelmivene",
  "item.minecraft.zombie_spawn_egg": "Luo zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Luo zombikyläläinen",
  "item.minecraft.zombified_piglin_spawn_egg": "Luo zombipiglin"
}
export const fi_fi = items; 
